import React, { lazy } from 'react';

import AccessDenied from 'Pages/InnerPages/AccessDenied';
import Company from 'Pages/InnerPages/Company/Company';
import MenuAdd from 'Pages/InnerPages/MenuMaster/Index';

import { Index as CreditCardPaymentIndex } from 'Pages/InnerPages/CreditCardPayment/Index';
import { Index as DMTSettings } from 'Pages/InnerPages/DMTSettings/Index';
import { Index as PPISetting } from 'Pages/InnerPages/PPISetting/Index';
import { Index as VerificationSettings } from 'Pages/InnerPages/VerificationSetting/index';
import { Index as DematSetting } from 'Pages/InnerPages/DematSetting/Index';
import { Index as UPITransferSettings } from 'Pages/InnerPages/UPITransferSetting/Index';
import { Index as AccountOpenSettings } from 'Pages/InnerPages/AccountOpenSetting/Index';
import { Index as CIBILScoreSetting } from 'Pages/InnerPages/CIBILScoreSetting/Index';

import { Index as CyberPlateSettings } from 'Pages/InnerPages/CyberPlateSetting/Index';
import { AdminAccounting } from 'Pages/InnerPages/AdminAccounting/Index';
import { Report as AEPSReport } from 'Pages/InnerPages/AEPS/Report';
import { Report as MicroATMReport } from 'Pages/InnerPages/MicroATM/Report';
import { POSReport } from 'Pages/InnerPages/POS/Report';
import { CMSReport } from 'Pages/InnerPages/CMS/Report';
import { BalanceCappingUserwise } from 'Pages/InnerPages/BalanceCapping/Index';
import { Add as BBPSConfigurationAdd } from 'Pages/InnerPages/BBPSConfiguration/Add';
import { Edit as BBPSConfigurationEdit } from 'Pages/InnerPages/BBPSConfiguration/Edit';
import { BBPSConfiguration } from 'Pages/InnerPages/BBPSConfiguration/Index';
import { Index as BulkMessageIndex } from 'Pages/InnerPages/BulkMessage/Index';
import { CallbackAdd } from 'Pages/InnerPages/CallbackMaster/CallbackAdd';
import { CallbackEdit } from 'Pages/InnerPages/CallbackMaster/CallbackEdit';
import { CallMeRequest } from 'Pages/InnerPages/CallMeRequest/Add';
import { CallRequestReport } from 'Pages/InnerPages/CallMeRequest/Index';
import { CashCollect } from 'Pages/InnerPages/CashCollection/Add';
import { CashCollectionReport } from 'Pages/InnerPages/CashCollection/Index';

import { CashCollectionReverse } from 'Pages/InnerPages/CashCollection/Reverse';
import { BeneficiaryAdd as CDMTBeneficiaryAdd } from 'Pages/InnerPages/CDMT/BeneficiaryAdd';
import { BeneficiaryDelete as CDMTBeneficiaryDelete } from 'Pages/InnerPages/CDMT/BeneficiaryDelete';
import { DMTTransfer as CDMTTransfer } from 'Pages/InnerPages/CDMT/DMTTransfer';
import { SenderAdd as CDMTSenderAdd } from 'Pages/InnerPages/CDMT/SenderAdd';
import { SenderSearch as CDMTSenderSearch } from 'Pages/InnerPages/CDMT/SenderSearch';
import { SenderVerify as CDMTSenderVerify } from 'Pages/InnerPages/CDMT/SenderVerify';
import { CircleAPIAdd } from 'Pages/InnerPages/CircleAPI/Add';

import { Complaints } from 'Pages/InnerPages/Complaints/Index';

import { DistributorDashboardV2 } from 'Pages/InnerPages/DashBoard/DistributorDashboardV2';
import { RetailerDashboard } from 'Pages/InnerPages/DashBoard/RetailerDashboard';
import { ProviderDayBookReport } from 'Pages/InnerPages/DayBookReport/ProviderDayBook';
import { DaybookReport } from 'Pages/InnerPages/DayBookReport/Select';
import { DenominationAdd } from 'Pages/InnerPages/Denomination/Add';
import { DenominationMapping } from 'Pages/InnerPages/DenominationMapping/Index';
import { DenominationDetails } from 'Pages/InnerPages/DenominationMapping/DenominationDetails';

import { EcollectionSetting } from 'Pages/InnerPages/EcollectionSetting/Index';
import { EmailAdd } from 'Pages/InnerPages/EmailSetting/EmailAdd';
import { EmailEdit } from 'Pages/InnerPages/EmailSetting/EmailEdit';
import { EmailSetting } from 'Pages/InnerPages/EmailSetting/Index';
import { EcollectionReport } from 'Pages/InnerPages/Fund/EcollectionReport';
import { FundRequestIndex } from 'Pages/InnerPages/Fund/Index';
import { Reverse } from 'Pages/InnerPages/Fund/Reverse';
import { ReverseRequest } from 'Pages/InnerPages/Fund/ReverseRequest';
import { ReverseRequestReport } from 'Pages/InnerPages/Fund/ReverseRequestReport';
import { ReverseTransferReport } from 'Pages/InnerPages/Fund/ReverseTransferReport';
import { Transfer } from 'Pages/InnerPages/Fund/Transfer';
import { FundTransferReport } from 'Pages/InnerPages/Fund/TransferReport';
import { BeneficiaryAdd as IDMTBeneficiaryAdd } from 'Pages/InnerPages/IDMT/BeneficiaryAdd';
import { BeneficiaryDelete as IDMTBeneficiaryDelete } from 'Pages/InnerPages/IDMT/BeneficiaryDelete';
import { SenderAdd as IDMTSenderAdd } from 'Pages/InnerPages/IDMT/SenderAdd';
import { SenderSearch as IDMTSenderSearch } from 'Pages/InnerPages/IDMT/SenderSearch';
import { SenderVerify as IDMTSenderVerify } from 'Pages/InnerPages/IDMT/SenderVerify';

import { BeneficiaryVerify as MahagramDMTBeneficiaryVerify } from 'Pages/InnerPages/MahagramDMT/BeneficiaryVerify';
import { BeneficiaryAdd as MahagramDMTBeneficiaryAdd } from 'Pages/InnerPages/MahagramDMT/BeneficiaryAdd';

import { SenderAdd as MahagramDMTSenderAdd } from 'Pages/InnerPages/MahagramDMT/SenderAdd';
import { BeneficiaryGetOTP as MahagramDMTBeneGetOTP } from 'Pages/InnerPages/MahagramDMT/BeneficiaryGetOTP';
import { SenderSearch as MahagramDMTSenderSearch } from 'Pages/InnerPages/MahagramDMT/SenderSearch';
import { SenderVerify as MahagramDMTSenderVerify } from 'Pages/InnerPages/MahagramDMT/SenderVerify';

import { BeneficiaryAdd as MMoneyDMTBeneficiaryAdd } from 'Pages/InnerPages/MasterMoneyDMT/BeneficiaryAdd';
import { SenderAdd as MMoneyDMTSenderAdd } from 'Pages/InnerPages/MasterMoneyDMT/SenderAdd';
import { SenderSearch as MMoneyDMTSenderSearch } from 'Pages/InnerPages/MasterMoneyDMT/SenderSearch';

import { SenderSearch as WhiteLabelPaytmCCFSenderSearch } from 'Pages/InnerPages/WhiteLabelPaytmCCF/SenderSearch';
import { SenderAdd as WhiteLabelPaytmCCFDMTSenderAdd } from 'Pages/InnerPages/WhiteLabelPaytmCCF/SenderAdd';
import { BeneficiaryVerify as WhiteLabelPaytmCCFDMTBeneficiaryVerify } from 'Pages/InnerPages/WhiteLabelPaytmCCF/BeneficiaryVerify';
import { BeneficiaryAdd as WhiteLabelPaytmCCFDMTBeneficiaryAdd } from 'Pages/InnerPages/WhiteLabelPaytmCCF/BeneficiaryAdd';
import { BeneficiaryDelete as WhiteLabelPaytmCCFDMTBeneficiaryDelete } from 'Pages/InnerPages/WhiteLabelPaytmCCF/BeneficiaryDelete';

import { BeneficiaryAdd as MMoneyPDMTBeneficiaryAdd } from 'Pages/InnerPages/MasterMoneyPureDMT/BeneficiaryAdd';
import { SenderAdd as MMoneyPDMTSenderAdd } from 'Pages/InnerPages/MasterMoneyPureDMT/SenderAdd';
import { SenderSearch as MMoneyPDMTSenderSearch } from 'Pages/InnerPages/MasterMoneyPureDMT/SenderSearch';
import { SenderVerify as MMoneyPDMTSenderVerify } from 'Pages/InnerPages/MasterMoneyPureDMT/SenderVerify';

import { SenderAdd as EDMTSenderAdd } from 'Pages/InnerPages/EDMT/SenderAdd';
import { SenderSearch as EDMTSenderSearch } from 'Pages/InnerPages/EDMT/SenderSearch';
import { SenderVerify as EDMTSenderVerify } from 'Pages/InnerPages/EDMT/SenderVerify';
import { BeneficiaryAdd as EDMTBeneficiaryAdd } from 'Pages/InnerPages/EDMT/BeneficiaryAdd';
import { BeneficiaryDelete as EDMTBeneficiaryDelete } from 'Pages/InnerPages/EDMT/BeneficiaryDelete';
import { BeneficiaryVerify as EDMTBeneficiaryVerify } from 'Pages/InnerPages/EDMT/BeneficiaryVerify';

import { SenderAdd as ICompositeDMTSenderAdd } from 'Pages/InnerPages/ICompositeDMT/SenderAdd';
import { SenderSearch as ICompositeDMTSenderSearch } from 'Pages/InnerPages/ICompositeDMT/SenderSearch';
import { SenderVerify as ICompositeDMTSenderVerify } from 'Pages/InnerPages/ICompositeDMT/SenderVerify';
import { BeneficiaryAdd as ICompositeDMTBeneficiaryAdd } from 'Pages/InnerPages/ICompositeDMT/BeneficiaryAdd';
import { BeneficiaryVerify as ICompositeDMTBeneficiaryVerify } from 'Pages/InnerPages/ICompositeDMT/BeneficiaryVerify';

import { SenderAdd as RazorpayDMTSenderAdd } from 'Pages/InnerPages/RazorpayDMT/SenderAdd';
import { SenderSearch as RazorpayDMTSenderSearch } from 'Pages/InnerPages/RazorpayDMT/SenderSearch';
import { SenderVerify as RazorpayDMTSenderVerify } from 'Pages/InnerPages/RazorpayDMT/SenderVerify';
import { BeneficiaryAdd as RazorpayDMTBeneficiaryAdd } from 'Pages/InnerPages/RazorpayDMT/BeneficiaryAdd';
import { BeneficiaryVerify as RazorpayDMTBeneficiaryVerify } from 'Pages/InnerPages/RazorpayDMT/BeneficiaryVerify';

import { SenderAdd as JaiJuiDMTSenderAdd } from 'Pages/InnerPages/JaiJuiDMT/SenderAdd';
import { SenderSearch as JaiJuiDMTSenderSearch } from 'Pages/InnerPages/JaiJuiDMT/SenderSearch';
import { SenderVerify as JaiJuiSenderVerify } from 'Pages/InnerPages/JaiJuiDMT/SenderVerify';
import { BeneficiaryAdd as JaiJuiBeneficiaryAdd } from 'Pages/InnerPages/JaiJuiDMT/BeneficiaryAdd';
import { BeneficiaryVerify as JaiJuiDMTBeneficiaryVerify } from 'Pages/InnerPages/JaiJuiDMT/BeneficiaryVerify';

import { SenderAdd as CommonDMTAsPayoutSenderAdd } from 'Pages/InnerPages/CommonDMTAsPayout/SenderAdd';
import { SenderSearch as CommonDMTAsPayoutSenderSearch } from 'Pages/InnerPages/CommonDMTAsPayout/SenderSearch';
import { SenderSearch as DMTAsPayoutSenderSearch } from 'Pages/InnerPages/CommonDMTAsPayout/SenderSearch';

import { SenderAdd as UPISenderAdd } from 'Pages/InnerPages/UpiTransferV2/SenderAdd';
import { SenderSearch as UPISenderSearch } from 'Pages/InnerPages/UpiTransferV2/SenderSearch';
import { SenderVerify as UPISenderVerify } from 'Pages/InnerPages/UpiTransferV2/SenderVerify';
import { BeneficiaryAdd as UPIBeneficiaryAdd } from 'Pages/InnerPages/UpiTransferV2/BeneficiaryAdd';
import { BeneficiaryVerify as UPIBeneficiaryVerify } from 'Pages/InnerPages/UpiTransferV2/BeneficiaryVerify';

import { SenderVerify as CommonDMTAsPayoutSenderVerify } from 'Pages/InnerPages/CommonDMTAsPayout/SenderVerify';
import { BeneficiaryAdd as CommonDMTAsPayoutBeneficiaryAdd } from 'Pages/InnerPages/CommonDMTAsPayout/BeneficiaryAdd';
import { BeneficiaryVerify as CommonDMTAsPayoutBeneficiaryVerify } from 'Pages/InnerPages/CommonDMTAsPayout/BeneficiaryVerify';

import { SenderAdd as PrimePayDMTenderAdd } from 'Pages/InnerPages/PrimePayDMT/SenderAdd';
import { SenderSearch as PrimePayDMTSenderSearch } from 'Pages/InnerPages/PrimePayDMT/SenderSearch';
import { SenderVerify as PrimePayDMTSenderVerify } from 'Pages/InnerPages/PrimePayDMT/SenderVerify';
import { BeneficiaryAdd as PrimePayDMTBeneficiaryAdd } from 'Pages/InnerPages/PrimePayDMT/BeneficiaryAdd';
import { BeneficiaryVerify as PrimePayDMTBeneficiaryVerify } from 'Pages/InnerPages/PrimePayDMT/BeneficiaryVerify';

import { SenderAdd as HyptoDMTenderAdd } from 'Pages/InnerPages/HyptoDMT/SenderAdd';
import { SenderSearch as HyptoDMTSenderSearch } from 'Pages/InnerPages/HyptoDMT/SenderSearch';
import { SenderVerify as HyptoDMTSenderVerify } from 'Pages/InnerPages/HyptoDMT/SenderVerify';
import { BeneficiaryAdd as HyptoDMTBeneficiaryAdd } from 'Pages/InnerPages/HyptoDMT/BeneficiaryAdd';
import { BeneficiaryVerify as HyptoDMTBeneficiaryVerify } from 'Pages/InnerPages/HyptoDMT/BeneficiaryVerify';

import { CreateVPA as PSCreateVPA } from 'Pages/InnerPages/PaymentGateway/PaysprintUPI/CreateVPA';
import { CreateQR as RPCreateQR } from 'Pages/InnerPages/PaymentGateway/RazorPayQR/CreateQR';

import { VirtualAccountCreate } from 'Pages/InnerPages/PaymentGateway/EaseBuzzQR/CreateStaticQR';

import { SenderAdd as ZplusPayoutDMTenderAdd } from 'Pages/InnerPages/ZplusPayoutDMT/SenderAdd';
import { SenderSearch as ZPlusPayoutDMTSenderSearch } from 'Pages/InnerPages/ZplusPayoutDMT/SenderSearch';
import { SenderVerify as ZplusPayoutDMTSenderVerify } from 'Pages/InnerPages/ZplusPayoutDMT/SenderVerify';
import { BeneficiaryAdd as ZplusPayoutDMTBeneficiaryAdd } from 'Pages/InnerPages/ZplusPayoutDMT/BeneficiaryAdd';
import { BeneficiaryVerify as ZplusPayoutDMTBeneficiaryVerify } from 'Pages/InnerPages/ZplusPayoutDMT/BeneficiaryVerify';

import { SenderAdd as CFDMTSenderAdd } from 'Pages/InnerPages/CFDMT/SenderAdd';

import { SenderVerify as CFSenderVerify } from 'Pages/InnerPages/CFDMT/SenderVerify';
import { BeneficiaryAdd as CFBeneficiaryAdd } from 'Pages/InnerPages/CFDMT/BeneficiaryAdd';
import { BeneficiaryVerify as CFDMTBeneficiaryVerify } from 'Pages/InnerPages/CFDMT/BeneficiaryVerify';

import { SenderAdd as AmbikaDMTSenderAdd } from 'Pages/InnerPages/AmbikaDMT/SenderAdd';
import { SenderSearch as AmbikaDMTSenderSearch } from 'Pages/InnerPages/AmbikaDMT/SenderSearch';
import { SenderVerify as AmbikaDMTSenderVerify } from 'Pages/InnerPages/AmbikaDMT/SenderVerify';
import { BeneficiaryAdd as AmbikaDMTBeneficiaryAdd } from 'Pages/InnerPages/AmbikaDMT/BeneficiaryAdd';
import { BeneficiaryVerify as AmbikaDMTBeneficiaryVerify } from 'Pages/InnerPages/AmbikaDMT/BeneficiaryVerify';

import { SenderAdd as RoundPayDMTSenderAdd } from 'Pages/InnerPages/RoundPayDMT/SenderAdd';
import { SenderSearch as RoundPayDMTSenderSearch } from 'Pages/InnerPages/RoundPayDMT/SenderSearch';
import { SenderVerify as RoundPayDMTSenderVerify } from 'Pages/InnerPages/RoundPayDMT/SenderVerify';
import { BeneficiaryAdd as RoundPayDMTBeneficiaryAdd } from 'Pages/InnerPages/RoundPayDMT/BeneficiaryAdd';
import { BeneficiaryVerify as RoundPayDMTBeneficiaryVerify } from 'Pages/InnerPages/RoundPayDMT/BeneficiaryVerify';

import { SenderAdd as VastWebDMTSenderAdd } from 'Pages/InnerPages/VastWebDMT/SenderAdd';
import { SenderVerify as VastWebDMTSenderVerify } from 'Pages/InnerPages/VastWebDMT/SenderVerify';
import { BeneficiaryAdd as VastWebDMTBeneficiaryAdd } from 'Pages/InnerPages/VastWebDMT/BeneficiaryAdd';
import { BeneficiaryAdd as IMPSGuruBeneficiaryAdd } from 'Pages/InnerPages/IMPSGuruDMT/BeneficiaryAdd';

import { SenderAdd as LevinDMTSenderAdd } from 'Pages/InnerPages/LevinDMT/SenderAdd';
import { SenderVerify as LevinDMTSenderVerify } from 'Pages/InnerPages/LevinDMT/SenderVerify';
import { BeneficiaryAdd as LevinDMTBeneficiaryAdd } from 'Pages/InnerPages/LevinDMT/BeneficiaryAdd';

import { SenderAdd as ClareInfoTechDMTSenderAdd } from 'Pages/InnerPages/ClareInfoTechDMT/SenderAdd';
import { BeneficiaryAdd as ClareInfoTechDMTBeneficiaryAdd } from 'Pages/InnerPages/ClareInfoTechDMT/BeneficiaryAdd';
import { SenderSearch as ClareInfoTechDMTSenderSearch } from 'Pages/InnerPages/ClareInfoTechDMT/SenderSearch';
import { SenderVerify as ClareInfoTechDMTSenderVerify } from 'Pages/InnerPages/ClareInfoTechDMT/SenderVerify';
import { BeneficiaryVerify as ClareInfoTechDMTBeneficiaryVerify } from 'Pages/InnerPages/ClareInfoTechDMT/BeneficiaryVerify';
import { BeneDeleteVerify as ClareInfoTechDMTBeneDeleteVerify } from 'Pages/InnerPages/ClareInfoTechDMT/BeneDeleteVerify';

import { SenderSearch as VastWebDMTSenderSearch } from 'Pages/InnerPages/VastWebDMT/SenderSearch';
import { SenderSearch as IMPSGuruDMTSenderSearch } from 'Pages/InnerPages/IMPSGuruDMT/SenderSearch';
import { SenderSearch as LevinDMTSenderSearch } from 'Pages/InnerPages/LevinDMT/SenderSearch';

import { Index as Invoice } from 'Pages/InnerPages/Invoice/Index';
import { Index as InvoiceSettings } from 'Pages/InnerPages/InvoiceSetting/Index';
import { IPAdd } from 'Pages/InnerPages/IPMaster/Add';
import { PendingIP } from 'Pages/InnerPages/IPMaster/SelectPendingIP';
import { KYCApprove } from 'Pages/InnerPages/KYC/index';
import { KYCSetting } from 'Pages/InnerPages/KYC/KycSetting';

import { LapuAccounting } from 'Pages/InnerPages/LapuAccounting/Add';
import { LapuMapping } from 'Pages/InnerPages/LapuAccounting/LapuMapping';
import { LapuPurchase } from 'Pages/InnerPages/LapuAccounting/LapuPurchase';
import { LapuUsage } from 'Pages/InnerPages/LapuAccounting/LapuUsageReport';

import { BeneficiaryAdd as MDMTBeneficiaryAdd } from 'Pages/InnerPages/MDMT/BeneficiaryAdd';
import { DMTTransfer as MDMTTransfer } from 'Pages/InnerPages/MDMT/DMTTransfer';

import { MessageSetting } from 'Pages/InnerPages/MessageSetting/Index';

import { WebHookSetting } from 'Pages/InnerPages/WebHookSetting/Index';

import { News } from 'Pages/InnerPages/News/Index';
import { NotificationAdd } from 'Pages/InnerPages/Notification/Notification';
import { OfflineProduct } from 'Pages/InnerPages/OfflineProduct/Index';
import { OfflineBook } from 'Pages/InnerPages/Transaction/OfflineBooking';
import { OperatorUserwise } from 'Pages/InnerPages/OperatorUserwise/Index';
import { OperatorWiseViewProvider } from 'Pages/InnerPages/OperatorWiseViewProvider';
import { OutsideRoleSetting } from 'Pages/InnerPages/OutsideRoleSetting/Index';
import { IPGTransaction } from 'Pages/InnerPages/PaymentGateway/IPGTransaction';
import { PGFail } from 'Pages/InnerPages/PaymentGateway/PGFail';
import { PGSuccess } from 'Pages/InnerPages/PaymentGateway/PGSuccess';
import { PTransaction } from 'Pages/InnerPages/PaymentGateway/PTransaction';
import { CTransaction } from 'Pages/InnerPages/PaymentGateway/CTransaction';
import { PayUTransaction } from 'Pages/InnerPages/PaymentGateway/PayUTransaction';

import { IMoneyPayTransaction } from 'Pages/InnerPages/PaymentGateway/IMoneyPayTransaction';
import { PayGoalTransaction } from 'Pages/InnerPages/PaymentGateway/PayGoalTransaction';

import { CheckCIBILScore } from 'Pages/InnerPages/CheckCIBILScore/CheckCIBILScore';

//import { UGTransaction } from 'Pages/InnerPages/PaymentGateway/UGTransaction';
import { GatewayTransaction } from 'Pages/InnerPages/PaymentGateway/Transaction';
import { CreditCardToBank } from 'Pages/InnerPages/CreditCardToBank/CreditCardToBank';
import { UPIGatewayTransaction } from 'Pages/InnerPages/PaymentGateway/UPIGatewayTransaction';
import { PaymentGateWaySetting } from 'Pages/InnerPages/PaymentGatewaySetting/Index';

import { UserwisePaymentGateway } from 'Pages/InnerPages/PaymentGatewaySetting/UserwisePaymentGateway';
import { AEPSSetting } from 'Pages/InnerPages/AEPSSetting/Index';
import { MicroATMSetting } from 'Pages/InnerPages/MicroATMSetting/Index';
import { POSSetting } from 'Pages/InnerPages/POSSettingMaster/Index';

import { PayoutTransaction } from 'Pages/InnerPages/Payout/PayoutTransaction';
import { PayoutTransactionV1 } from 'Pages/InnerPages/PayoutV1/PayoutTransaction';
import { PayoutTransactionV2 } from 'Pages/InnerPages/NSDLPayout/PayoutTransaction';
import { OnlyApiPayoutTransaction } from 'Pages/InnerPages/OnlyApiPayout/OnlyApiPayoutTransaction';

import { E_Payout as EZYPayoutSenderSearch } from 'Pages/InnerPages/PayoutV1/E_Payout/EzyPayPayout';
import { AddContact as EzyPayoutAddContact } from 'Pages/InnerPages/PayoutV1/E_Payout/AddContact';

import { SmartPayTransaction } from 'Pages/InnerPages/SmartPay/SmartPayTransaction';
import { OTTTransaction } from 'Pages/InnerPages/OTT/Paysprint/Web/OTTIndex';

import { BeneficiaryReport } from 'Pages/InnerPages/PayoutV1/BeneficiaryReport';
import { NSDLBeneficiaryReport } from 'Pages/InnerPages/PayoutV1/NSDLBenificiaryReport';
import { OnlyApiBeneficiaryReport } from 'Pages/InnerPages/OnlyApiPayout/OnlyApiBeneficiaryReport'
import { BeneficiaryAdd as PDMTBeneficiaryAdd } from 'Pages/InnerPages/PDMT/BeneficiaryAdd';
import { BeneficiaryAdd as ICashDMTBeneficiaryAdd } from 'Pages/InnerPages/ICashDMT/BeneficiaryAdd';
import {
    BeneficiaryVerify as MDMTBeneficiaryVerify,
    BeneficiaryVerify as PDMTBeneficiaryVerify,
    BeneficiaryVerify as ICashDMTBeneficiaryVerify
} from 'Pages/InnerPages/PDMT/BeneficiaryVerify';
import { DMTTransfer as PDMTTransfer } from 'Pages/InnerPages/PDMT/DMTTransfer';
import { DMTTransfer as ICashDMTTransfer } from 'Pages/InnerPages/ICashDMT/DMTTransfer';

import CircleSwitching from 'Pages/InnerPages/ProviderConfiguration/CircleSwitching';
import { CircleIndex } from 'Pages/InnerPages/ProviderConfiguration/CircleIndex';
import { AddPurchase } from 'Pages/InnerPages/ProviderPurchase/Add';
import { ProviderResponseAdd } from 'Pages/InnerPages/ProviderResponse/Add';
import { UserAlias } from 'Pages/InnerPages/Users/UserAlias';

import { Index as PushNotificationsIndex } from 'Pages/InnerPages/PushNotifications/Index';
import { QRCodeGenerate } from 'Pages/InnerPages/QR/QRCodeGenerate';
import { ReconciliationUpload } from 'Pages/InnerPages/Reconciliation/Upload';
import { ReconciliationSettingsAdd } from 'Pages/InnerPages/ReconciliationSettings/Add';
import { ReconciliationSettingsEdit } from 'Pages/InnerPages/ReconciliationSettings/Edit';
import { ReconciliationSettings } from 'Pages/InnerPages/ReconciliationSettings/Index';

import { SmsReport } from 'Pages/InnerPages/SentSms/Index';
import { SequenceUserWiseAdd } from 'Pages/InnerPages/SequenceUserWise/SequenceUserWiseAdd';
import { UserWiseDMTSequenceAdd } from 'Pages/InnerPages/SequenceUserWise/UserwiseDMTSequenceAdd';

import { UserwiseSequenceIndex } from 'Pages/InnerPages/SequenceUserWise/Index';
import { UserWiseCircleAdd } from 'Pages/InnerPages/CircleWiseUserWiseOperatorOff/UserwiseCircleAdd';
import { UserwiseCircleIndex } from 'Pages/InnerPages/CircleWiseUserWiseOperatorOff/Index';

import { ServiceChargeDeductionReport } from 'Pages/InnerPages/ServiceChargeDeduction/Report';
import { Services } from 'Pages/InnerPages/Services/Index';
import { UserwiseServiceCharge } from 'Pages/InnerPages/Services/UserwiseServiceCharge';
import { ServiceSubscriptionCharge } from 'Pages/InnerPages/ServiceSubscriptionCharge';
import { PendingSubcriptionCharge } from 'Pages/InnerPages/Report/PendingSubscriptionCharge';
import { SubscriptionPendingPayment } from 'Pages/InnerPages/ServiceSubscriptionCharge/SubscriptionPendingPayment';
import { SelectSettingMaster } from 'Pages/InnerPages/SettingMaster/Index';
import { SettingEdit } from 'Pages/InnerPages/SettingMaster/SettingEdit';
import { AdjustCommission } from 'Pages/InnerPages/Slabs/AdjustCommissions';
import { RangeWiseSequence } from 'Pages/InnerPages/Sequence/RangeWiseSequence';

import { Index as SliderIndex } from 'Pages/InnerPages/Slider/Index';
import { SMSAdd } from 'Pages/InnerPages/SMS/SMSAdd';
import { SupportAccess } from 'Pages/InnerPages/SupportUser/Index';
import { MainManuSubManuAccess } from 'Pages/InnerPages/MainManuSubManuAccess/Index';
import { Index as ThirdPartyServiceProvider } from 'Pages/InnerPages/ThirdPartyServiceProvider/Index';
import { InstaProvider } from 'Pages/InnerPages/ThirdPartyServiceProvider/InstaProvider';
import { Ticket } from 'Pages/InnerPages/Ticket/Add';
import { TicketReport } from 'Pages/InnerPages/Ticket/Index';
import UISetting from 'Pages/InnerPages/UISettings/Index';
import { UserActionHistory } from 'Pages/InnerPages/UserActionHistory/Index';
import { BankAdd } from 'Pages/InnerPages/UserBankDetail/UserBankDetailAdd';
import { IPRegistration } from 'Pages/InnerPages/UserOnbording/IPRegistration';
import { EkoUserOnbording } from 'Pages/InnerPages/UserOnbording/EkoUserOnbording';
import { IPRegistrationOTP } from 'Pages/InnerPages/UserOnbording/IPRegistrationOTP';
import { IPChangeMobile } from 'Pages/InnerPages/UserOnbording/IPChangeMobile';
import { IPChangeMoblieVerify } from 'Pages/InnerPages/UserOnbording/IPChangeMoblieVerify';
import DownlineReport from 'Pages/InnerPages/Users/DownlineReport';
import InActiveUsers from 'Pages/InnerPages/Users/InActiveUsers';
import UserWiseBulkAction from 'Pages/InnerPages/Users/UserWiseBulkAction';
import UserWiseBulkActionSDAndDist from 'Pages/InnerPages/Users/UserWiseBulkActionSDAndDist';

import DeletedUsers from 'Pages/InnerPages/Users/DeletedUsers';
import { UserToken } from 'Pages/InnerPages/Users/UserToken';
import { VirtualBalanceAdd } from 'Pages/InnerPages/VirtualBalance/Add';
import WalletTransfer from 'Pages/InnerPages/WalletTransfer/WalletTransfer';
import RetailerToAllFundTransfer from 'Pages/InnerPages/Fund/RetailerToAllFundTransfer';
import InstantPayeKYC from 'Pages/InnerPages/eKYC/InstantPay_eKYC';
import PaysprinteKYC from 'Pages/InnerPages/eKYC/Paysprint_eKYC';
import QuickeKYC from 'Pages/InnerPages/eKYC/Quick_eKYC';
import { IndexPaysprint } from 'Pages/InnerPages/eKYC/IndexPaysprint_eKYC';

import IndexCashFree from 'Pages/InnerPages/eKYC/Cashfree/IndexCashfree';
import { PADRSAadhar } from 'Pages/InnerPages/eKYC/PDRS_Aadhar';
import { PaySprintCMSInitiate } from 'Pages/InnerPages/CMS/PaySprintInitiate';
import { FingpayInsuranceInitiate } from 'Pages/InnerPages/Insurance/FingpayInsuranceInitiate';

import { Status as XMPPStatus } from 'Pages/InnerPages/XMPP/Status';
import InnerLayout from 'Pages/Layouts/InnerLayout';
import InnerLayoutRoute from 'Pages/Layouts/InnerLayoutRoute';
import { Route } from 'react-router-dom';

import { SenderAdd as EkoDMTSenderAdd } from 'Pages/InnerPages/EkoDMT/SenderAdd';
import { SenderSearch as EkoDMTSenderSearch } from 'Pages/InnerPages/EkoDMT/SenderSearch';
import { SenderVerify as EkoDMTSenderVerify } from 'Pages/InnerPages/EkoDMT/SenderVerify';
import { BeneficiaryAdd as EkoDMTBeneficiaryAdd } from 'Pages/InnerPages/EkoDMT/BeneficiaryAdd';

import { Add } from 'Pages/InnerPages/ChannelSlab/Add';
import { AssignEdit } from 'Pages/InnerPages/ChannelSlab/ChannalSlabAssignEdit';
import { ChannelSlabAssign } from 'Pages/InnerPages/ChannelSlab/ChannelSlabAssign';
import { ChannelSlabCommission } from 'Pages/InnerPages/ChannelSlab/ChannelSlabCommission';
import { DMTChannelSlabCommission } from 'Pages/InnerPages/ChannelSlab/DMTChannelSlabCommission';
import { AEPSIndex } from 'Pages/InnerPages/AEPS/AEPSIndex';
import { PaytmAEPS } from 'Pages/InnerPages/AEPS/PaytmAEPS';
import { AlleAEPS } from 'Pages/InnerPages/AEPS/AlleAEPS';

import { PaysprintAEPS } from 'Pages/InnerPages/AEPS/PaysprintAEPS';
import { CredoPayAEPS } from 'Pages/InnerPages/AEPS/CredoPay/CredoPayAEPS';
import { CredoPayAuthentication } from 'Pages/InnerPages/AEPS/CredoPay/CredoPayAuthentication';

import { PaysprintAEPSAuthentication } from 'Pages/InnerPages/AEPS/PaysprintDailyAuthentication';
import { PaysprintAEPSAuthenticationManual } from 'Pages/InnerPages/AEPS/PaysprintAEPSAuthenticationManual';
import { PaysprintAEPSGetLocation } from 'Pages/InnerPages/AEPS/PaysprintAEPSGetLocation';

import { VleRegistration } from 'Pages/InnerPages/PanMitra/VleRegistration';
import { CouponBuy } from 'Pages/InnerPages/PanMitra/CouponBuy';
import { FingPayTwoFactorAuthentication } from 'Pages/InnerPages/AEPS/FingPayTwoFactorAuthentication';

import { PaysprintUserOnbording } from 'Pages/InnerPages/AEPS/PaysprintUserOnbording';
import { AdminDashboardV2 } from 'Pages/InnerPages/DashboradV2';
import { Request } from 'Pages/InnerPages/Fund/Request';
import { Upload } from 'Pages/InnerPages/KYC/Upload';
import { SenderAdd as MDMTSenderAdd } from 'Pages/InnerPages/MDMT/SenderAdd';
import { SenderSearch as MDMTSenderSearch } from 'Pages/InnerPages/MDMT/SenderSearch';
import { SenderVerify as MDMTSenderVerify } from 'Pages/InnerPages/MDMT/SenderVerify';
import { HLR } from 'Pages/InnerPages/Operators/HLR';
import { HLREdit } from 'Pages/InnerPages/Operators/HLREdit';
import { Operators } from 'Pages/InnerPages/Operators/Index';
import { OperatorAdd } from 'Pages/InnerPages/Operators/OperatorAdd';
import { OperatorEdit } from 'Pages/InnerPages/Operators/OperatorEdit';
import { AddRemainderOperatorAmount } from 'Pages/InnerPages/OperatorAmountWiseRemainderSetting/Add';
import { SenderAdd as ICashDMTSenderAdd } from 'Pages/InnerPages/ICashDMT/SenderAdd';
import { SenderSearch as ICashDMTSenderSearch } from 'Pages/InnerPages/ICashDMT/SenderSearch';
import { SenderVerify as ICashDMTSenderVerify } from 'Pages/InnerPages/ICashDMT/SenderVerify';

import { SenderAdd as PDMTSenderAdd } from 'Pages/InnerPages/PDMT/SenderAdd';
import { SenderSearch as PDMTSenderSearch } from 'Pages/InnerPages/PDMT/SenderSearch';
import { SenderVerify as PDMTSenderVerify } from 'Pages/InnerPages/PDMT/SenderVerify';

import { SenderAdd as PayUDMTSenderAdd } from 'Pages/InnerPages/PayUDMT/SenderAdd';
import { SenderSearch as PayUDMTSenderSearch } from 'Pages/InnerPages/PayUDMT/SenderSearch';
import { SenderVerify as PayUDMTSenderVerify } from 'Pages/InnerPages/PayUDMT/SenderVerify';
import { BeneficiaryAdd as PayUDMTBeneficiaryAdd } from 'Pages/InnerPages/PayUDMT/BeneficiaryAdd';
import { BeneficiaryVerify as PayUDMTBeneficiaryVerify } from 'Pages/InnerPages/PayUDMT/BeneficiaryVerify';

import { SenderAdd as MyNetLinkSenderAdd } from 'Pages/InnerPages/MyNetLinkDMT/SenderAdd';
import { SenderSearch as MyNetLinkSenderSearch } from 'Pages/InnerPages/MyNetLinkDMT/SenderSearch';
import { DMTTransfer as MyNetLinkTransfer } from 'Pages/InnerPages/MyNetLinkDMT/DMTTransfer';
import { BeneficiaryAdd as MyNetLinkBeneficiaryAdd } from 'Pages/InnerPages/MyNetLinkDMT/BeneficiaryAdd';
import { SenderAdd as NTDMTSenderAdd } from 'Pages/InnerPages/NovityDMT/SenderAdd';
import { SenderSearch as NTDMTSenderSearch } from 'Pages/InnerPages/NovityDMT/SenderSearch';
import { SenderVerify as NTDMTSenderVerify } from 'Pages/InnerPages/NovityDMT/SenderVerify';
import { BeneficiaryAdd as NTDMTBeneficiaryAdd } from 'Pages/InnerPages/NovityDMT/BeneficiaryAdd';
import { BeneficiaryVerify as NTDMTBeneVerify } from 'Pages/InnerPages/NovityDMT/BeneficiaryVerify';
import { BeneDeleteVerify as NTDMTBeneDeleteVerify } from 'Pages/InnerPages/NovityDMT/BeneDeleteVerify';
import { AgentRegistration as NTDMTAgentRegistration } from 'Pages/InnerPages/NovityDMT/AgentRegistration';
import { GenerateSenderOTP as NTDMTGenerateSenderOTP } from 'Pages/InnerPages/NovityDMT/GenerateSenderOTP';
import { SenderEKYC as NTDMTSenderEKYC } from 'Pages/InnerPages/NovityDMT/SenderEKYC';
import { TransactionConfirmation as NTDMTTransactionConfirmation } from 'Pages/InnerPages/NovityDMT/TransactionConfirmation';
import { SplitAmount as NTDMTSplitAmount } from 'Pages/InnerPages/NovityDMT/SplitAmount';
import { AirtelBankSenderAdd as NTDMTAirtelBankSenderAdd } from 'Pages/InnerPages/NovityDMT/AirtelBankSenderAdd';
import { AirtelBankSenderVerify as NTDMTAirtelBankSenderVerify } from 'Pages/InnerPages/NovityDMT/AirtelBankSenderVerify';
import { AirtelSenderEKYC as NTDMTAirtelSenderEKYC } from 'Pages/InnerPages/NovityDMT/AirtelBankSenderEKYC';
import { NSDLBank3SenderAdharVerifyEKYC as NTDMTNSDLBank3SenderAdharVerifyEKYC } from 'Pages/InnerPages/NovityDMT/NSDLBank3SenderAdharVerifyEKYC';
import { NSDLBankSenderAdd as NTDMTNSDLBankSenderAdd } from 'Pages/InnerPages/NovityDMT/NSDLBankSenderAdd';
import { NSDLBankSenderOTPVerify as NTDMTNSDLBankSenderOTPVerify } from 'Pages/InnerPages/NovityDMT/NSDLBankSenderOTPVerify';

import { SenderRegistration as KYCPPISenderRegistration } from 'Pages/InnerPages/KYCPPI/SenderRegistration';
import { SenderVerify as KYCPPI_SenderVerify } from 'Pages/InnerPages/KYCPPI/SenderVerify';
import { SenderSearch as KYCPPI_SenderSearch } from 'Pages/InnerPages/KYCPPI/SenderSearch';
import KYCPPI_eKYC from 'Pages/InnerPages/KYCPPI/SendereKYC';
import { BeneficiaryAdd as KYCPPI_BeneficiaryAdd } from 'Pages/InnerPages/KYCPPI/BeneficiaryAdd';
import { TransactionConfirmation as KYCPPITransactionConfirmation } from 'Pages/InnerPages/KYCPPI/TransactionConfirmation';
import { SplitAmount as ICICISplitAmount } from 'Pages/InnerPages/KYCPPI/SplitAmount';

import { SenderSearch as NTDMT5LSenderSearch } from 'Pages/InnerPages/Novity5LDMT/SenderSearch';
import { AgentRegistration as NTDMT5LAgentRegistration } from 'Pages/InnerPages/Novity5LDMT/AgentRegistration';
import { SenderAdd as NTDMT5LSenderAdd } from 'Pages/InnerPages/Novity5LDMT/SenderAdd';
import { BeneficiaryVerify as NTDMT5LBeneVerify } from 'Pages/InnerPages/Novity5LDMT/BeneficiaryVerify';
import { SenderVerify as NTDMT5LSenderVerify } from 'Pages/InnerPages/Novity5LDMT/SenderVerify';
import { BeneficiaryAdd as NT5LDMTBeneficiaryAdd } from 'Pages/InnerPages/Novity5LDMT/BeneficiaryAdd';
import { BeneDeleteVerify as NTDMT5LBeneDeleteVerify } from 'Pages/InnerPages/Novity5LDMT/BeneDeleteVerify';

import { ProviderConfigSetup } from 'Pages/InnerPages/ProviderConfiguration/Index';
import { ProviderOperatorEdit } from 'Pages/InnerPages/ProviderConfiguration/ProviderConfigurationEdit';
import { ProviderDetailAdd } from 'Pages/InnerPages/ProviderDetails/ProviderDetailAdd';
import { ProviderDetailEdit } from 'Pages/InnerPages/ProviderDetails/ProviderDetailEdit';
import { ProviderAdd } from 'Pages/InnerPages/Providers/ProviderAdd';
import { DMTPipeMaster } from 'Pages/InnerPages/Report/DMTPipeMaster';
import { ProviderEdit } from 'Pages/InnerPages/Providers/ProviderEdit';
import { Edit as SequenceEdit } from 'Pages/InnerPages/Sequence/Edit';
import { SequenceAdd } from 'Pages/InnerPages/Sequence/SequenceAdd';
import { DMTSlabCommission } from 'Pages/InnerPages/Slabs/DMTSlabCommission';
import { OfflineSlabCommission } from 'Pages/InnerPages/Slabs/OfflineSlabCommission';
import { SeviceswiseWallet } from 'Pages/InnerPages/Services/SeviceswiseWallet';
import { ROfferCommissionAdd } from 'Pages/InnerPages/Slabs/ROfferCommissionAdd';
import { UserWiseLatLong } from 'Pages/InnerPages/Users/UserWiseLatLong';
import { SlabAdd } from 'Pages/InnerPages/Slabs/SlabAdd';
import { SlabAssign } from 'Pages/InnerPages/Slabs/SlabAssign';
import { SlabAssignEdit } from 'Pages/InnerPages/Slabs/SlabAssignEdit';
import { SlabCommission } from 'Pages/InnerPages/Slabs/SlabCommission';
import { Transaction } from 'Pages/InnerPages/Transaction/Index';
import { BBPSTransaction } from 'Pages/InnerPages/Transaction/BBPSTransaction';
import { UpdatePassword } from 'Pages/InnerPages/Users/ChangePassword';
import { DatewiseUserReport } from 'Pages/InnerPages/Users/DatewiseUserReport';
import { Users } from 'Pages/InnerPages/Users/Index';
import { SelectProfile } from 'Pages/InnerPages/Users/Profile';
import { UserAdd } from 'Pages/InnerPages/Users/UserAdd';
import { UserEdit } from 'Pages/InnerPages/Users/UserEdit';
import UserTransfer from 'Pages/InnerPages/Users/UserTransfer';
import { UserwiseSaleTarget } from 'Pages/InnerPages/Users/UserwiseSaleTarget';
import { UserwiseSaleTargetReport } from 'Pages/InnerPages/Users/UserwiseSaleTargetReport';
import { OfflineBookReport } from 'Pages/InnerPages/OfflineBooking/Index';
import { SubscriptionRenew } from 'Pages/InnerPages/Subscription/Index';
import { TwoFA } from 'Pages/InnerPages/Users/2FA';
import AgreementForm from 'Pages/InnerPages/MerchantOnboardingAgreement/AgreementForm';

import { PrepaidActivation } from 'Pages/InnerPages/Transaction/PrepaidActivation';
import { PrepaidActivationReport } from 'Pages/InnerPages/PrepaidActivation/Index';
import { DigitalCertificateIndex } from 'Pages/InnerPages/Certificate/DigitalCertificateIndex';
import { VersionHistory } from 'Pages/InnerPages/VersionHistory/Index';

import { Index as ServiceWiseSliderIndex } from 'Pages/InnerPages/ServiceWiseSlider/Index';
import { VirtualAccountSetting } from 'Pages/InnerPages/VirtualAccount/Index';

import { PlanSetting } from 'Pages/InnerPages/PlanSetting/Index';

import { DematGrowthLoss } from 'Pages/InnerPages/Demat/DematGrowthLoss';

import { UserwiseLowBalance } from 'Pages/InnerPages/UserwiseLowBalance/Index';
import { DMTBankSetting } from 'Pages/InnerPages/DMTSettings/DMTBankSetting';
import { DMTTransaction } from 'Pages/InnerPages/Transaction/DMTTransaction';

import { PPITransaction } from 'Pages/InnerPages/Transaction/PPITransaction';

import { UPITransfer } from 'Pages/InnerPages/UPITransfer/UPITransferIndex';

import { CommonUPITransfer } from 'Pages/InnerPages/UPITransfer/CommonUPITransfer';
import { TransferUPI } from 'Pages/InnerPages/UPITransfer/UPITransfer';

import { MyNetLinkUPITransfer } from 'Pages/InnerPages/UPITransfer/MyNetLinkUPITransfer';
import { ClickPayUPITransfer } from 'Pages/InnerPages/UPITransfer/ClickPayUPITransfer';

import { AccountOpeningIndex } from 'Pages/InnerPages/AccountOpening/AccountOpeningIndex';
import { CheckCustomer } from 'Pages/InnerPages/LoanDistributor/CheckCustomer';
import { CustomerRegistration } from 'Pages/InnerPages/LoanDistributor/CustomerRegistration';
import { LoginCustomer } from 'Pages/InnerPages/LoanDistributor/LoginCustomer';
import { CibilDetails } from 'Pages/InnerPages/LoanDistributor/CibilDetails';
import { PaysprintAccountOpen } from 'Pages/InnerPages/AccountOpening/Paysprint/PaysprintAccountOpen';
import { UserOnbording } from 'Pages/InnerPages/AccountOpening/Paysprint/PaysprintUserOnbording';
import { CasaUserOnbording } from 'Pages/InnerPages/CasaDMT/CasaUserOnbording';

import { PaysprintPaytmOnboarding } from 'Pages/InnerPages/AEPS/PaysprintPaytmAEPS/PaysprintPaytmOnboarding';
import { PaysprintPaytmAEPS } from 'Pages/InnerPages/AEPS/PaysprintPaytmAEPS/PaysprintPaytmAEPS';
import { PaysprintPaytmAEPSAuthentication } from 'Pages/InnerPages/AEPS/PaysprintPaytmAEPS/PaysprintPaytmAEPSAuthentication';

import { InstantPayMerchantOnboarding } from 'Pages/InnerPages/AEPS/InstantPayAEPS/InstantPayMerchantOnboarding';
import { InstantPayAEPS } from 'Pages/InnerPages/AEPS/InstantPayAEPS/InstantPayAEPS';
import { InstantPayAEPSAuthentication } from 'Pages/InnerPages/AEPS/InstantPayAEPS/InnstantPayAEPSAuthentication';

import { NSDLBankAEPS } from 'Pages/InnerPages/AEPS/NSDLAEPS/NSDLBankAEPS';
import { NSDLBankAEPSAuthentication } from 'Pages/InnerPages/AEPS/NSDLAEPS/NSDLBankAEPSAuthentication';
import { NSDLBankAEPSTerminalRegister } from 'Pages/InnerPages/AEPS/NSDLAEPS/NSDLBankAEPSTerminalRegister';

import { OnlyApiAEPSAuthentication } from 'Pages/InnerPages/AEPS/OnlyApiAEPS/OnlyApiAEPSAuthentication';
import { OnlyApiAEPSTerminalRegistration } from 'Pages/InnerPages/AEPS/OnlyApiAEPS/OnlyApiAEPSTerminalRegistration';
import { OnlyApiAEPS } from 'Pages/InnerPages/AEPS/OnlyApiAEPS/OnlyApiAEPS';

import { OTTIndex } from 'Pages/InnerPages/OTT/OTTIndex';

import { LeadGenerationIndex } from 'Pages/InnerPages/LeadGeneration/LeadGenerationIndex';
import { OverdraftRequest } from 'Pages/InnerPages/Overdraft/OverdraftRequest';
import { OverdraftRequestIndex } from 'Pages/InnerPages/Overdraft/Index';
import { OverdraftReverseReport } from 'Pages/InnerPages/Overdraft/OverdraftReverseReport';
import { OverdraftTransferReport } from 'Pages/InnerPages/Overdraft/TransferReport';

import { OverdraftSetting } from 'Pages/InnerPages/Overdraft/OverdraftSetting';
import { DthCategoryChannel } from 'Pages/InnerPages/CategoryChannelMapping/Index';
import { DthPackageChannel } from 'Pages/InnerPages/DthPackageChannelMapping/Index';

import { EkoAgentActivation } from 'Pages/InnerPages/AEPS/EkoAgentActivation';
import { FingpayAEPS } from 'Pages/InnerPages/AEPS/FingpayAEPS';
import { FingPayUserOnbording } from 'Pages/InnerPages/AEPS/FingPayUserOnbording';
import { FingpaySendOTP } from 'Pages/InnerPages/AEPS/FingpaySendOTP';
import { FingpayValidateOTP } from 'Pages/InnerPages/AEPS/FingPayValidateOTP';
import { FingPayBiomatric } from 'Pages/InnerPages/AEPS/FingPayBiomatric';

import { OneClickAEPS } from 'Pages/InnerPages/AEPS/OneClickAEPS';
import { OneClickUserOnbording } from 'Pages/InnerPages/AEPS/OneClickUserOnbording';
import { OneClickSendOTP } from 'Pages/InnerPages/AEPS/OneClickSendOTP';
import { OneClickValidateOTP } from 'Pages/InnerPages/AEPS/OneClickValidateOTP';
import { OneClickTwoFactorAuthentication } from 'Pages/InnerPages/AEPS/OneClickTwoFactorAuthentication';
import { OneClickBiomatric } from 'Pages/InnerPages/AEPS/OneClickBiomatric';

import { MahagramRegistration } from 'Pages/InnerPages/AEPS/MahagramRegistration';
import { MahagramAEPS } from 'Pages/InnerPages/AEPS/MahagramAEPS';
import { EkoAEPS } from 'Pages/InnerPages/AEPS/EkoAEPS';
import { ApiClubAEPS } from 'Pages/InnerPages/AEPS/ApiClubAEPS';
import { ApiClubUserOnbording } from 'Pages/InnerPages/AEPS/ApiClubUserOnbording';
import { ApiClubSendOTP } from 'Pages/InnerPages/AEPS/ApiClubSendOTP';
import { ApiClubValidateOTP } from 'Pages/InnerPages/AEPS/ApiClubValidateOTP';
import { ApiClubBiomatric } from 'Pages/InnerPages/AEPS/ApiClubBiomatric';

import { RegisterComplaint } from 'Pages/InnerPages/RaiseComplaint/RegisterComplaint';
import { ComplaintStatus } from 'Pages/InnerPages/RaiseComplaint/ComplaintStatus';

import { PayoutSetting } from 'Pages/InnerPages/PayoutSetting/Index';
import { BulkPaySetting } from 'Pages/InnerPages/BulkPaySetting/Index';
import { BusSettingMaster } from 'Pages/InnerPages/BusSettingMaster/Index';
import { RichTextMedia } from 'Pages/InnerPages/RichTextMedia/Index';

import { OTTSetting } from 'Pages/InnerPages/OTTSetting/Index';
import { EKYCSetting } from 'Pages/InnerPages/eKYCSetting/Index';
import { CreditInstitutionSetting } from 'Pages/InnerPages/CreditInstitutionSetting/Index';
import { UserWisePlanLimitSetting } from 'Pages/InnerPages/UserWisePlanLimitSetting/index';

import { LeadGeneration } from 'Pages/InnerPages/LeadGenerationMaster/LeadGeneration';
import { OnlyAPILeadGeneration } from 'Pages/InnerPages/LeadGeneration/OnlyAPILeadGeneratuon';

import { KycIndex } from 'Pages/InnerPages/KYC/KycIndex';

import { Approve } from 'Pages/InnerPages/KYC/Approve';
import { EkoAEPSenderVerify } from 'Pages/InnerPages/AEPS/EkoAEPSenderVerify';
import { EkoAEPSSenderAdd } from 'Pages/InnerPages/AEPS/EkoAEPSSenderAdd';

import ManualSuccessFailReport from 'Pages/InnerPages/Report/ManualSuccessFailReport';
import PastSuccessFailReport from 'Pages/InnerPages/Report/PastSuccessFailReport';

import LiveTransaction from 'Pages/InnerPages/Report/LiveTransactions';
import { DMTReport } from 'Pages/InnerPages/Report/DMTReport';
import { PPIReport } from 'Pages/InnerPages/Report/PPIReport';
import { IDPurchaseReport } from 'Pages/InnerPages/Report/IDPurchaseReport';
import { PaymentGatewayLog } from 'Pages/InnerPages/Report/PaymentGatewayLogReport';
import { IncomeReport } from 'Pages/InnerPages/Report/IncomeReport';
import { DMTResendWallet } from 'Pages/InnerPages/Report/DMTResendWallet';
import { RangewiseDMT } from 'Pages/InnerPages/Report/RangeWiseDMTReport';
import { UserWiseDMTRangeReport } from 'Pages/InnerPages/Report/UserWiseDMTRangeReport';
import { SplitAmount as EZPV1SplitAmount } from 'Pages/InnerPages/EzyPayV1DMT/SplitAmount';

import { RangeWiseRecharge } from 'Pages/InnerPages/Report/RangeWiseRecharge';

import { CMSTransaction } from 'Pages/InnerPages/Report/CMSTransaction';
import { AdminLedger } from 'Pages/InnerPages/Report/AdminLedger';
import { APIUserInitialLog } from 'Pages/InnerPages/Report/APIUserInitialLog';
import { GSTSummary } from 'Pages/InnerPages/Report/GSTsummary';
import { GSTHold } from 'Pages/InnerPages/Report/GSTHold';
import { UserReferralReport } from 'Pages/InnerPages/Report/UserReferralReport';
import { OperatorWiseUserWiseReport } from 'Pages/InnerPages/Report/OperatorWiseUserWiseReport';
import { ReferredUserReport } from 'Pages/InnerPages/Report/ReferredUserReport';

import { ReferAndEarn } from 'Pages/InnerPages/ReferAndEarn/Index';
import { CommissionHold } from 'Pages/InnerPages/CommissionHold/CommissionHold';
import { CommissionHoldRequest } from 'Pages/InnerPages/CommissionHold/Request';
import { CommissionHoldReport } from 'Pages/InnerPages/Report/CommissionHoldReport';

import { AutoBalanceTransfer } from 'Pages/InnerPages/Users/AutoBalanceTransfer';
import { LapuReport } from 'Pages/InnerPages/Report/LapuwiseReport';
import { LedgerReport } from 'Pages/InnerPages/Report/Ledger';
import { SelectByIDLog } from 'Pages/InnerPages/Report/LogByTransactionMasterID';
import { NPerformance } from 'Pages/InnerPages/Report/NPerformance';
import { PaymentGatewayReport } from 'Pages/InnerPages/Report/PaymentGatewayReport';
import { PayoutReport } from 'Pages/InnerPages/Report/PayoutReport';
import { VendorPayReport } from 'Pages/InnerPages/Report/VendorPayReport';
import { UserWisePlanViewReport } from 'Pages/InnerPages/Report/UserWisePlanViewReport';

import { Loan } from 'Pages/InnerPages/DealOffLoan/Index';
import { UPITransferReport } from 'Pages/InnerPages/Report/UPITransferReport';
import { ProviderWisePerformanceGraph } from 'Pages/InnerPages/Report/ProviderWisePerformanceGraph';
import { OTTReport } from 'Pages/InnerPages/Report/OTTReport';
import { BusBookingReport } from 'Pages/InnerPages/Report/BusBookingReport';
import { AccountOpeningReport } from 'Pages/InnerPages/Report/AccountOpeningReport';
import { CIBILScoreReport } from 'Pages/InnerPages/Report/CIBILScoreReport';
import { PendingDmt } from 'Pages/InnerPages/Report/PendingDmt';
import { PendingUPI } from 'Pages/InnerPages/Report/PendingUPI';

import { PendingRecharge } from 'Pages/InnerPages/Report/PendingRecharge';
import { PendingProviderRecharge } from 'Pages/InnerPages/Report/PendingProviderRecharge';
import { APIFailure } from 'Pages/InnerPages/Report/ProviderFailure';
import { ProviderLog } from 'Pages/InnerPages/Report/ProviderRequestResponse';
import { WebHookLog } from 'Pages/InnerPages/Report/WebHookLog';
import { ProviderSale } from 'Pages/InnerPages/Report/ProviderSale';
import { AmountWiseInsights } from 'Pages/InnerPages/Report/AmountWiseInsights';
import { ProviderWiseFailReport } from 'Pages/InnerPages/Report/ProviderWiseFailReason';
import { RetailerSearch } from 'Pages/InnerPages/Report/QuickSearch';
import { ActiveReport } from 'Pages/InnerPages/Report/ActiveReport';
import { PaysprintRedirectURL as PSRedirectURL } from 'Pages/InnerPages/PaymentGateway/PaysprintRedirectURL';
import { Search } from 'Pages/InnerPages/Report/SearchConsumerNumber';
import { ServicewiseSale } from 'Pages/InnerPages/Report/ServicewiseSale';
import { SlabDetailByUser } from 'Pages/InnerPages/Report/SlabDetailByUser';
import { TransactionDetailReport } from 'Pages/InnerPages/Report/TransactionDetailReport';
import { Demat } from 'Pages/InnerPages/Demat/Demat';
import { DematReport } from 'Pages/InnerPages/Demat/Report';
import { UserOnboarding } from 'Pages/InnerPages/MorePayOnbording/UserOnboarding';
import { EKYCOTP } from 'Pages/InnerPages/MorePayOnbording/EKYCOTP';
import { NSDL } from 'Pages/InnerPages/NSDL/NSDL';
import { IndexMorePay } from 'Pages/InnerPages/MorePayOnbording/Index';

import { SenderAadharVerifyBank2 as PSSenderAadharVerifyBank2 } from 'Pages/InnerPages/PaysprintDMT/SenderAadharVerifyBank2';
import { SenderEKYCBank2 as PSSenderEKYCBank2 } from 'Pages/InnerPages/PaysprintDMT/SenderEKYCBank2';
import { SenderAdd as PSSenderAdd } from 'Pages/InnerPages/PaysprintDMT/SenderAdd';
import { BeneficiaryAdd as PSBeneficiaryAdd } from 'Pages/InnerPages/PaysprintDMT/BeneficiaryAdd';
import { BeneficiaryAdd as CSBeneficiaryAdd } from 'Pages/InnerPages/CasaDMT/BeneficiaryAdd';
import { ProviderCommission } from 'Pages/InnerPages/Slabs/ProviderCommission';
import { ProviderStateConfigSetup } from 'Pages/InnerPages/ProviderStateConfiguration/Index';
import { EnquiryReport } from 'Pages/InnerPages/Enquiry/Index';
import { CashCollectionReportV2 } from 'Pages/InnerPages/CashCollection/CashCollectionReportV2';
import { EzyPayOnboarding } from 'Pages/InnerPages/AEPS/EzyPayAEPS/EzyPayOnboarding';
import { PaysprintURLRedirect } from 'Pages/InnerPages/AccountOpening/Paysprint/PaysprintURLRedirect';
import { EzyPayAEPSAuthentication } from 'Pages/InnerPages/AEPS/EzyPayAEPS/EzyPayAEPSAuthentication';
import { EzyPayAEPS } from 'Pages/InnerPages/AEPS/EzyPayAEPS/EzyPayAEPS';
import { EPayOnboardingForAirtel } from 'Pages/InnerPages/AEPS/EzyPayAEPS/EPayOnboardingForAirtel';
import { APIAgentKYC } from 'Pages/InnerPages/AEPS/EzyPayAEPS/APIAgentKYC';
import { CircleWiseOperatorLimitAdd } from 'Pages/InnerPages/CircleWiseOperatorLimit/CircleWiseOperatorLimitAdd';
import { OperatorLimitIndex } from 'Pages/InnerPages/CircleWiseOperatorLimit/Index';
import { CircleWiseCommission } from 'Pages/InnerPages/Slabs/CircleWiseCommission';
import { AddOperatorAmount } from 'Pages/InnerPages/OperatorAmountWiseSetting/Add';
import { ROfferRechargeReport } from 'Pages/InnerPages/Report/ROfferRechargeReport';

import { SenderSearch as PaytmSenderSearch } from 'Pages/InnerPages/PDMT/SenderSearch';
import { SenderSearch as MyNetLinkDMTSenderSearch } from 'Pages/InnerPages/MyNetLinkDMT/SenderSearch';
import { SenderSearch as ICashSenderSearch } from 'Pages/InnerPages/ICashDMT/SenderSearch';

import { SenderSearch as IPSenderSearch } from 'Pages/InnerPages/IDMT/SenderSearch';
import { SenderSearch as ESenderSearch } from 'Pages/InnerPages/EDMT/SenderSearch';
import { SenderSearch as PaytmCCFSenderSearch } from 'Pages/InnerPages/PaytmCCFDMT/SenderSearch';
import { SenderSearch as MMoneySenderSearch } from 'Pages/InnerPages/MasterMoneyDMT/SenderSearch';
import { SenderSearch as MMoneyPSenderSearch } from 'Pages/InnerPages/MasterMoneyPureDMT/SenderSearch';
import { SenderSearch as ICompositeSenderSearch } from 'Pages/InnerPages/ICompositeDMT/SenderSearch';
import { SenderSearch as PaysprintDMTSenderSearch } from 'Pages/InnerPages/PaysprintDMT/SenderSearch';
import { SenderSearch as CASADMTSenderSearch } from 'Pages/InnerPages/CasaDMT/SenderSearch';

import { SenderSearch as CashFreeSenderSearch } from 'Pages/InnerPages/CFDMT/SenderSearch';
import EzyPaySenderSearch from 'Pages/InnerPages/EzyPayDMT/SenderSearch';
import EzyPayPaytmSenderSearch from 'Pages/InnerPages/EzyPayPaytmDMT/SenderSearch';
import EzyPayV1SenderSearch from 'Pages/InnerPages/EzyPayV1DMT/SenderSearch';

import NSDLBankSenderSearch from 'Pages/InnerPages/NSDLDMT/SenderSearch';

import OnlyApiSenderSearch from 'Pages/InnerPages/OnlyAPIDMT/SenderSearch';


import PayPointSenderAdd from 'Pages/InnerPages/PayPoint/SenderAdd';
import PaysprintAgentRegistration from 'Pages/InnerPages/PaysprintPPI/PaysprintPPIAgentRegistration'

import { NSDLRedirectURL } from 'Pages/InnerPages/NSDL/NSDLRedirectURL';
import { DematRedirectURL } from 'Pages/InnerPages/Demat/DematRedirectURL';
import { DematLoginRedirect } from 'Pages/InnerPages/Demat/DematLoginRedirect';
import { UserCreationSetting } from 'Pages/InnerPages/UserCreationSetting/Index';
import { IDPurchase } from 'Pages/InnerPages/UserCreation/Transaction';
import { FreeIDTransfer } from 'Pages/InnerPages/UserCreation/FreeIDTransfer';
import { SDKGenerateUrl } from 'Pages/InnerPages/SDK/GenerateURL';
import { URLRedirect as SDKURLRedirect } from 'Pages/InnerPages/SDK/URLRedirect';
import { SDKUserMapping } from 'Pages/InnerPages/SDKBBPSUserMapping/Index';
import { PaysprintPanRedirectURL } from 'Pages/InnerPages/PanCard/PaysprintPanRedirectURL';
import { PaysprintPPIRedirectURL } from 'Pages/InnerPages/PaysprintPPI/PaysprintPPIRedirectURL';
import { PanMitraRedirectURL } from 'Pages/InnerPages/PanCard/PanMitraRedirectURL';
import { UserWiseServiceSellReport } from 'Pages/InnerPages/Report/UserWiseServiceSellReport';
import { AddVoucher } from 'Pages/InnerPages/Voucher/AddVoucher';
import { ApproveVoucher } from 'Pages/InnerPages/Voucher/ApproveVoucher';
import { CreditRequest } from 'Pages/InnerPages/Fund/CreditRequest';
import { CreditRequestSetting } from 'Pages/InnerPages/Users/CreditRequestSetting';
import { ReportVoucher } from 'Pages/InnerPages/Voucher/ReportVoucher';
import { Outstanding } from 'Pages/InnerPages/Voucher/Outstanding';
import { DistributerOutStandingDetailsReport } from 'Pages/InnerPages/Voucher/DistributerOutstandingDetailsReport';
import { VoucherModeReport } from 'Pages/InnerPages/Voucher/VoucherModeReport';
import { SenderAdd as IMPSGuruDMTSenderAdd } from 'Pages/InnerPages/IMPSGuruDMT/SenderAdd';
import { BalanceSheetReport } from 'Pages/InnerPages/Voucher/BalanceSheetReport';
import { ActionController } from 'Pages/InnerPages/ActionControllerMenu';
import { AddBeneficiary } from 'Pages/InnerPages/CreditInstitution/AddBeneficiary';
import { CreditInstitutionIndex } from 'Pages/InnerPages/CreditInstitution/CreditInstitutionIndex';
import { ViewBeneficiary } from 'Pages/InnerPages/CreditInstitution/ViewBeneficiary';
import { AddAndManageBeneficiary } from 'Pages/InnerPages/CreditInstitution/AddAndManageBeneficiary';
import { OtherBankBeneficiary } from 'Pages/InnerPages/CreditInstitution/OtherBankBeneficiary';
import { BankToOtherTransfer } from 'Pages/InnerPages/CreditInstitution/BankToOtherTransfer';
import { BankToBankTransfer } from 'Pages/InnerPages/CreditInstitution/BankToBankTransfer';
import { SelfTransfer } from 'Pages/InnerPages/CreditInstitution/SelfTransfer';
import AccountStatement from 'Pages/InnerPages/IDFCAccountStatement/AccountStatement';
import { PayoutBulkTransfer } from 'Pages/InnerPages/PayoutBulkTransfer/PayoutBulkTransfer';
import { ViewOwnBeneficiary } from 'Pages/InnerPages/CreditInstitution/ViewOwnBeneficiary';
import { OwnBankBeneficiary } from 'Pages/InnerPages/CreditInstitution/OwnBankBeneficiary';
import { AddOwnBeneficiary } from 'Pages/InnerPages/CreditInstitution/AddOwnBeneficiary';
import { MerchantOnboarding } from 'Pages/InnerPages/NSDLOnboarding/NSDLOnboarding';
import { OnboardingReport } from 'Pages/InnerPages/NSDLOnboarding/OnboardingReport';
import { OnlyAPIOnboarding } from 'Pages/InnerPages/OnlyAPIOnboarding/OnlyAPIOnboarding';
import { EditNSDLOnboarding } from 'Pages/InnerPages/NSDLOnboarding/EditNSDLOnboarding';
import { BulkOnboarding } from 'Pages/InnerPages/NSDLOnboarding/BulkOnboarding';
import { OnlyAPIBulkOnboarding } from 'Pages/InnerPages/OnlyAPIOnboarding/OnlyAPIBulkOnboarding';
import { BulkUpdateTIDMID } from 'Pages/InnerPages/NSDLOnboarding/BulkUpdateTIDMID';

const AlleDMTBeneficiaryAdd = lazy(() =>
    import('Pages/InnerPages/AlleDMT/BeneficiaryAdd')
);

const RapiPayAEPS = lazy(() => import('Pages/InnerPages/AEPS/RapiPayAEPS'));
const AlleDMTSenderAdd = lazy(() =>
    import('Pages/InnerPages/AlleDMT/SenderAdd')
);
const AlleDMTSenderSearch = lazy(() =>
    import('Pages/InnerPages/AlleDMT/SenderSearch')
);
const AlleDMTSenderVerify = lazy(() =>
    import('Pages/InnerPages/AlleDMT/SenderVerify')
);

const ZPlusDMTSenderSearch = lazy(() =>
    import('Pages/InnerPages/ZPlusDMT/SenderSearch')
);
const ZPlusDMTSenderAdd = lazy(() =>
    import('Pages/InnerPages/ZPlusDMT/SenderAdd')
);

const ZPlusDMTSenderVerify = lazy(() =>
    import('Pages/InnerPages/ZPlusDMT/SenderVerify')
);

const ZPlusDMTBeneficiaryAdd = lazy(() =>
    import('Pages/InnerPages/ZPlusDMT/BeneficiaryAdd')
);

const PSSenderAuthentication = lazy(() =>
    import('Pages/InnerPages/PaysprintDMT/SenderAuthentication')
);

const PaysprintAuthentication = lazy(() =>
    import('Pages/InnerPages/AEPS/PaysprintAuthentication')
);

const CSSenderAuthentication = lazy(() =>
    import('Pages/InnerPages/CasaDMT/SenderAuthentication')
);

const PSTransactionConfirmation = lazy(() =>
    import('Pages/InnerPages/PaysprintDMT/TransactionConfirmation')
);

const CSTransactionConfirmation = lazy(() =>
    import('Pages/InnerPages/CasaDMT/TransactionConfirmation')
);

const PSSplitAmount = lazy(() =>
    import('Pages/InnerPages/PaysprintDMT/SplitAmount')
);

const CSSplitAmount = lazy(() =>
    import('Pages/InnerPages/CasaDMT/SplitAmount')
);

const OnlyApiSenderAdd = lazy(() =>
    import('Pages/InnerPages/OnlyAPIDMT/SenderAdd')
);

const OnlyApiGenerateSenderKYCOTP = lazy(() =>
    import('Pages/InnerPages/OnlyAPIDMT/GenerateSenderOTP')
);

const OnlyApiVerifySenderKYCOTP = lazy(() =>
    import('Pages/InnerPages/OnlyAPIDMT/VerifySenderOTP')
);

const OnlyApiSenderKYCAuthentication = lazy(() =>
    import('Pages/InnerPages/OnlyAPIDMT/SenderAuthentication')
);

const OnlyApiBeneficiaryADD = lazy(() =>
    import('Pages/InnerPages/OnlyAPIDMT/BeneficiaryAdd')
);

const OnlyApiSplitAmount = lazy(() =>
    import('Pages/InnerPages/OnlyAPIDMT/SplitAmount')
);

const NSDLSenderAdd = lazy(() =>
    import('Pages/InnerPages/NSDLDMT/SenderAdd')
);

const GenerateSenderKYCOTP = lazy(() =>
    import('Pages/InnerPages/NSDLDMT/GenerateSenderOTP')
);

const VerifySenderKYCOTP = lazy(() =>
    import('Pages/InnerPages/NSDLDMT/VerifySenderOTP')
);

const SenderKYCAuthentication = lazy(() =>
    import('Pages/InnerPages/NSDLDMT/SenderAuthentication')
);

const BeneficiaryADD = lazy(() =>
    import('Pages/InnerPages/NSDLDMT/BeneficiaryAdd')
);

const NBSplitAmount = lazy(() =>
    import('Pages/InnerPages/NSDLDMT/SplitAmount')
);

const EzyPayV1DMTSenderAdd = lazy(() =>
    import('Pages/InnerPages/EzyPayV1DMT/SenderAdd')
);

const EzyPayV1GenerateSenderOTP = lazy(() =>
    import('Pages/InnerPages/EzyPayV1DMT/GenerateSenderOTP')
);

const EzyPayV1VerifySenderOTP = lazy(() =>
    import('Pages/InnerPages/EzyPayV1DMT/VerifySenderOTP')
);

const EzyPayV1SenderAuthentication = lazy(() =>
    import('Pages/InnerPages/EzyPayV1DMT/SenderAuthentication')
);

const EzyPayV1DMTSenderVerify = lazy(() =>
    import('Pages/InnerPages/EzyPayV1DMT/SenderVerify')
);
const EzyPayV1DMTBeneficiaryAdd = lazy(() =>
    import('Pages/InnerPages/EzyPayV1DMT/BeneficiaryAdd')
);
const TransactionConfirmation = lazy(() =>
    import('Pages/InnerPages/EzyPayV1DMT/TransactionConfirmation')
);

const PayPointGenerateAadharOTP = lazy(() =>
    import('Pages/InnerPages/PayPoint/GenerateAadharOTP')
);

const PayPointVerifySenderOTP = lazy(() =>
    import('Pages/InnerPages/PayPoint/VerifySenderOTP')
);

const PayPointVerifyAadharOTP = lazy(() =>
    import('Pages/InnerPages/PayPoint/ValidateAadharOTP')
);

const PayPointPanCardKYC = lazy(() =>
    import('Pages/InnerPages/PayPoint/PanCardKYC')
);

const PayPointBeneficiaryAdd = lazy(() =>
    import('Pages/InnerPages/PayPoint/BeneficiaryAdd')
);

const PayPointBenificiaryList = lazy(() =>
    import('Pages/InnerPages/PayPoint/BeneficiaryList')
);

const PayPointBeneDeleteOTP = lazy(() =>
    import('Pages/InnerPages/PayPoint/BeneDeleteOTP')
);

const EzyPayDMTSenderSearch = lazy(() =>
    import('Pages/InnerPages/EzyPayDMT/SenderSearch')
);
const EzyPayDMTSenderAdd = lazy(() =>
    import('Pages/InnerPages/EzyPayDMT/SenderAdd')
);

const EzyPayDMTSenderVerify = lazy(() =>
    import('Pages/InnerPages/EzyPayDMT/SenderVerify')
);

const EzyPayDMTBeneficiaryAdd = lazy(() =>
    import('Pages/InnerPages/EzyPayDMT/BeneficiaryAdd')
);
const EzyPayPaytmDMTSenderAdd = lazy(() =>
    import('Pages/InnerPages/EzyPayPaytmDMT/SenderAdd')
);

const EzyPayPaytmDMTSenderVerify = lazy(() =>
    import('Pages/InnerPages/EzyPayPaytmDMT/SenderVerify')
);

const EzyPayPaytmDMTBeneficiaryAdd = lazy(() =>
    import('Pages/InnerPages/EzyPayPaytmDMT/BeneficiaryAdd')
);

const OpenBankSenderSearch = lazy(() =>
    import('Pages/InnerPages/OpenBankDMT/SenderSearch')
);
const OpenBankSenderAdd = lazy(() =>
    import('Pages/InnerPages/OpenBankDMT/SenderAdd')
);
const OpenBankSenderVerify = lazy(() =>
    import('Pages/InnerPages/OpenBankDMT/SenderVerify')
);
const OpenBankBeneficiaryAdd = lazy(() =>
    import('Pages/InnerPages/OpenBankDMT/BeneficiaryAdd')
);
const OpenBankBeneficiaryVerify = lazy(() =>
    import('Pages/InnerPages/OpenBankDMT/BeneficiaryVerify')
);
const CashDepositReport = lazy(() =>
    import('Pages/InnerPages/Report/CashDepositReport')
);
const EasebuzzTransaction = lazy(() =>
    import('Pages/InnerPages/PaymentGateway/EasebuzzTransaction')
);
const UserwiseAccounting = lazy(() =>
    import('Pages/InnerPages/Report/UserwiseAccounting')
);
const UserwiseSale = lazy(() => import('Pages/InnerPages/Report/UserWiseSale'));
const OperatorSale = lazy(() => import('Pages/InnerPages/Report/OperatorSale'));
const SubscriptionChargeReport = lazy(() =>
    import('Pages/InnerPages/Report/SubscriptionChargeReport')
);
const GrowthLossReport = lazy(() =>
    import('Pages/InnerPages/Report/GrowthLossReport')
);

const AccountStatementReport = lazy(() =>
    import('Pages/InnerPages/Report/AccountStatementReport')
);

const SubscriptionPaymentReport = lazy(() =>
    import('Pages/InnerPages/Report/SubscriptionPaymentReport')
);

const ReporteKyc = lazy(() => import('Pages/InnerPages/eKYC/Report'));

const LoginHistory = lazy(() => import('Pages/InnerPages/Report/LoginHistory'));
const TDSReport = lazy(() => import('Pages/InnerPages/Report/TDSReport'));
const OperatorWiseGST = lazy(() =>
    import('Pages/InnerPages/Report/OperatorWiseGST')
);
const PaysprintPayout = lazy(() =>
    import('Pages/InnerPages/Payout/PaysprintPayout')
);

const PanCardSetting = lazy(() =>
    import('Pages/InnerPages/PanCardSetting/Index')
);

const LeadGenerationSetting = lazy(() =>
    import('Pages/InnerPages/LeadGenerationSetting/index')
);

const CMSSetting = lazy(() => import('Pages/InnerPages/CMSSetting/Index'));

const PurchaseReport = lazy(() =>
    import('Pages/InnerPages/Report/PurchaseReport')
);
const ChangeStatus = lazy(() => import('Pages/InnerPages/Report/ChangeStatus'));

const GSTReport = lazy(() => import('Pages/InnerPages/Report/GSTReport'));

const GSTDetails = lazy(() => import('Pages/InnerPages/Report/GSTDetails'));
const GSTDetailsV2 = lazy(() => import('Pages/InnerPages/Report/GSTDetailsV2'));
const PaysprintCreditCardPayment = lazy(() =>
    import('Pages/InnerPages/CreditCardPayment/PaysprintCreditCardPayment')
);
const PayUCreditCard = lazy(() =>
    import('Pages/InnerPages/CreditCardPayment/PayUCreditCard')
);
const CashfreeCreditCard = lazy(() =>
    import('Pages/InnerPages/CreditCardPayment/CashfreeCreditCard')
);
const MobikwikCreditCard = lazy(() =>
    import('Pages/InnerPages/CreditCardPayment/MobikwikCreditCard')
);
const InstantPayCreditCard = lazy(() =>
    import('Pages/InnerPages/CreditCardPayment/InstantPayCreditCard')
);

const CommonCreditCard = lazy(() =>
    import('Pages/InnerPages/CreditCardPayment/CommonCreditCard')
);

const CreditCardPaymentReport = lazy(() =>
    import('Pages/InnerPages/Report/CreditCardPaymentReport')
);
const CreditCardSetting = lazy(() =>
    import('Pages/InnerPages/CreditCardPaymentSetting/Index')
);

const EDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentEDMT')
);
const PCCFDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentPCCFDMT')
);

const CFDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentCFDMT')
);

const ADMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentADMT')
);
const EkoDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentEkoDMT')
);
const MDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentMDMT')
);
const PDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentPDMT')
);
const ICICI_CompositeDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentICICI_CompositeDMT')
);
const ICICI_CompositeDMTDoc = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocICICI_CompositeDmt')
);
const CommonDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentCommonDMT')
);

const ICashDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentICashDMT')
);
const CDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentCDMT')
);
const IDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentIDMT')
);
const MahagramDMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentMahagramDMT')
);
const AEPSDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentAEPS')
);
const DMTDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDOcumentDMT')
);
const Document = lazy(() => import('Pages/InnerPages/ApiDocument/APIDocument'));
const PlanApiDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentPlanApi')
);
const WebViewDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentWebView')
);

const UPIDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/UPIAPIDocument')
);
const PaysprintTransaction = lazy(() =>
    import('Pages/InnerPages/PaymentGateway/PaysprintTransaction')
);
const CashDepositSetting = lazy(() =>
    import('Pages/InnerPages/CashDepositSetting/Index')
);
const PaysprintCashDeposit = lazy(() =>
    import('Pages/InnerPages/CashDeposit/PaysprintCashDeposit')
);
const FingpayCashDeposit = lazy(() =>
    import('Pages/InnerPages/CashDeposit/FingpayCashDeposit')
);
const CashDepositIndex = lazy(() =>
    import('Pages/InnerPages/CashDeposit/Index')
);
const PayoutIndex = lazy(() => import('Pages/InnerPages/Payout/PayoutIndex'));

const PayoutIndexV1 = lazy(() =>
    import('Pages/InnerPages/PayoutV1/PayoutIndex')
);

const PaysprintUploadDocment = lazy(() =>
    import('Pages/InnerPages/Payout/PaysprintUploadDocment')
);
const IMoneyPayPayout = lazy(() =>
    import('Pages/InnerPages/Payout/IMoneyPayPayout')
);

const CashFreeTransaction = lazy(() =>
    import('Pages/InnerPages/PaymentGateway/CashFreeTransaction')
);

const JaiJuiPayout = lazy(() => import('Pages/InnerPages/Payout/JaiJuiPayout'));
const PPPayout = lazy(() => import('Pages/InnerPages/Payout/PrimePayPayout'));

const UserOnbordedReport = lazy(() =>
    import('Pages/InnerPages/Report/UserOnbordedReport')
);
const UserOnbordedStatusCheck = lazy(() =>
    import('Pages/InnerPages/Report/UserOnbordedStatusCheck')
);

const OpenBankPGTransaction = lazy(() =>
    import('Pages/InnerPages/PaymentGateway/OpenBankPGTransaction')
);
const RazorpayQRTransaction = lazy(() =>
    import('Pages/InnerPages/PaymentGateway/RazorpayQRTransaction')
);
const WalletTopUpIndex = lazy(() =>
    import('Pages/InnerPages/WalletTopUp/Index')
);
const PaysprintWalletTopUp = lazy(() =>
    import('Pages/InnerPages/WalletTopUp/PaysprintWalletTopUp')
);
const WalletTopUpReport = lazy(() =>
    import('Pages/InnerPages/Report/WalletTopUpReport')
);

const PanCardIndex = lazy(() =>
    import('Pages/InnerPages/PanCard/PanCardIndex')
);
const BusBookingIndex = lazy(() =>
    import('Pages/InnerPages/BusBooking/BusBookingIndex')
);
const PaySprintBusBooking = lazy(() =>
    import('Pages/InnerPages/BusBooking/PaysprintBusBooking')
);

const PaysprintPanCardGenerateURL = lazy(() =>
    import('Pages/InnerPages/PanCard/PaysprintPanCardGenerateURL')
);
const PanMitraPanCreation = lazy(() =>
    import('Pages/InnerPages/PanCard/PanMitraPanCreation')
);

const PaysprintLeadGenerationGenerateURL = lazy(() =>
    import('Pages/InnerPages/LeadGeneration/PaysprintLeadGenerationGenerateURL')
);
const PanCardReport = lazy(() =>
    import('Pages/InnerPages/Report/PanCardReport')
);

const LeadGenerationReport = lazy(() =>
    import('Pages/InnerPages/Report/LeadGenerationReport')
);

const ManualLeadGenerationReport = lazy(() =>
    import('Pages/InnerPages/Report/ManualLeadGenerationReport')
);

const PaidBillPaymentMasterReport = lazy(() =>
    import('Pages/InnerPages/Report/PaidBillPaymentMasterReport')
);

const SenderBeneficiaryReport = lazy(() =>
    import('Pages/InnerPages/SenderBeneficiary/SenderBeneficiaryReport')
);

const APIDocumentUPICF = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentUPICF')
);

const UPITransferAPIDocument = lazy(() =>
    import('Pages/InnerPages/ApiDocument/UPITransferAPIDocument')
);

const APIDocumentUPICP = lazy(() =>
    import('Pages/InnerPages/ApiDocument/APIDocumentUPICP')
);

const InnerLayoutNavigator = () => {
    const RoutePath = [
        '/PanCardIndex',
        '/BusBookingIndex',
        '/CPAEPS',
        '/LeadGenerationIndex',
        '/PanCardReport',
        '/LeadGenerationReport',
        '/ManualLeadGenerationReport',
        '/PaidBillPaymentMasterReport',
        '/CFTransaction',
        '/EBTransaction',
        '/WalletTopUpIndex',
        '/PSWalletTopUp',
        '/WalletTopUpReport',
        '/OBPGTransaction',
        '/ProviderCommission',
        '/ProviderStateConfigSetup',
        '/TDS',
        '/CashDepositIndex',
        '/CashDepositSetting',
        '/PSCashDepositPayment',
        '/FPCashDepositPayment',
        '/PSRedirectURL',
        '/UPIDocument',
        '/PCreditCardPayment',
        '/PUCreditCardPayment',
        '/CFCreditCardPayment',
        '/MkCreditCardPayment',
        '/IPCreditCardPayment',
        '/C_CreditCardPayment',
        '/CreditCardPaymentIndex',
        '/CreditCardReport',
        '/CreditCardSetting',
        '/PayoutSetting',
        '/RegisterComplaint',
        '/ComplaintStatus',
        '/BulkPaySetting',
        '/BusSettingMaster',
        '/RichTextMedia',
        '/OTTSetting',
        '/RPAEPS',
        '/EAgentActivation',
        '/EAEPS_SenderAdd',
        '/EAEPS_SenderVerify',
        '/FPUserOnbording',
        '/FPValidateOTP',
        '/FPBiomatric',
        '/FPSendOTP',

        '/OCUserOnbording',
        '/OCValidateOTP',
        '/OCSendOTP',
        '/OCBiomatric',

        '/PSPayout',
        '/PayoutTransaction',
        '/PayoutTransactionV1',
        '/PayoutTransactionV2',
        '/OnlyApiPayoutTransaction',
        '/E_Payout',
        '/AddContact',
        '/PayoutV1',
        '/UserwiseAccounting',
        '/PayoutBeneficiaryReport',
        '/NSDLBeneficiaryReport',
        '/OnlyApiBeneficiaryReport',
        '/PSUploadDocument',
        '/IMPPayout',
        '/JJPayoutTransfer',
        '/EzyPayPayoutTransfer',
        '/PPPayout',
        '/ZPPayout',
        '/EPayAEPSAuthentication',
        '/EPayAEPS',
        '/EPayOnboardingForAirtel',
        '/EPayOnboarding',
        '/APIAgentKYC',
        '/ACUserOnbording',
        '/ACValidateOTP',
        '/ACBiomatric',
        '/ACSendOTP',
        '/ACAEPS',

        '/EAEPS',
        '/GSTReport',
        '/GSTDetails',
        '/OperatorWiseGST',
        '/PurchaseReport',
        '/OverdraftRequest',
        '/OverdraftRequestReport',
        '/AEPSIndex',
        '/Income',
        '/PSAEPS',
        '/PSAEPSAuthentication',
        '/FPAuthentication',
        '/OCAuthentication',
        '/PSOnbording',
        '/PSAuthentication',
        '/CSOnbording',

        '/PSPOnbording',
        '/PSPAEPS',
        '/PSPAEPSAuthentication',

        '/IPMOnbording',
        '/IPAEPS',
        '/IPAEPSAuthentication',

        '/NBAEPS',
        '/NBAEPSAuthentication',
        '/NBAEPSTerminalRegister',

        '/OAAEPS',
        '/OAAEPSAuthentication',
        '/OAAEPSTerminalRegister',

        '/MRegistration',
        '/PAEPS',
        '/AlleAEPS',
        '/PaysprintURLRedirect',
        '/URLRedirect',
        '/AdminDashboard',
        '/Search',
        '/Users/UserAlias',
        '/RetailerSearch',
        '/ClientSearch',
        '/Pending',
        '/PendingDmt',
        '/PendingUPI',
        '/PendingProviderRecharge',
        '/DMTResendWallet',
        '/Recharge',
        '/ROfferRechargeReport',
        '/RangewiseDMT',
        '/UserWiseDMTRangeReport',
        '/RangeWiseRecharge',
        '/TransactionDetail',
        '/AccountStatement',
        '/Dashboard/Retailer',
        '/Fund',
        '/Fund/Request',
        '/Fund/Transfer',
        '/FundReverse',
        '/LoanDistributor',
        '/Fund/Report',
        '/Transaction',
        '/BharatConnectTransactions',
        '/DMTTransaction',
        '/DMTTransaction2',
        '/PPITransaction',
        '/CreditInstitutionIndex',
        '/AddAndManageBeneficiary',
        '/BankToOtherTransfer',
        '/BankToBankTransfer',
        '/SelfTransfer',
        '/OtherBankBeneficiary',
        '/OwnBankBeneficiary',
        '/UPITransfer',
        '/AccountOpening',
        '/NSDLUrl',
        '/OTTIndex',
        '/PS_AccountOpen',
        '/UserOnbording',
        '/CM_UPITransfer',
        '/TransferUPI',
        '/MNL_UPITransfer',
        '/CP_UPITransfer',

        '/KYC',
        '/KYC/Upload',
        '/Users',
        '/Users/Approve',
        '/Users/Add',
        '/Users/DatewiseReport',
        '/Users/DeletedUsers',
        '/Users/Edit',
        '/UsersProfile',
        '/Users/ChangePassword',
        '/Users/ChangeMpin',
        '/Users/Index',
        '/Users/UserTransfer',
        '/Users/UserwiseSaleTarget',
        '/Users/UserwiseSaleTargetReport',
        '/UserWiseLatLong',
        '/Services',
        '/Services/Index',
        '/Services/Add',
        '/Services/Edit',
        '/Operators',
        '/Operators/Index',
        '/Operators/Add',
        '/Operators/Edit',
        '/Operators/HLR',
        '/Operators/HLR/Edit',
        '/Providers',
        '/ProvidersAdd',
        '/Providers/Edit',
        '/ProvidersAdd/Add',

        '/ProviderDetails/Edit',
        '/ProviderConfiguration/Index',
        '/ProviderConfiguration/Edit',
        '/ProviderConfiguration',
        '/Slabs',
        '/Slabs/Edit',
        '/Slabs/Assign',
        '/Slabs/SlabAssignEdit',
        '/Slabs/Commission',
        '/Slabs/DMTCommission',
        '/ChannelSlabs/Commission',
        '/ChannelSlabs/DMTCommission',
        '/ProvidersSequence',
        '/Sequence',
        '/Sequence/Edit',
        '/Sequence/UserWise',
        '/UserWiseDMTSequenceAdd',
        '/PSTransaction',
        '/ROfferCommission',
        '/MDMT/Sender',
        '/MDMT/Sender/Search',
        '/MDMT/Transfer',
        '/MDMT/Sender/Add',
        '/MDMT/Sender/Verify',
        '/MDMT/Beneficiary/Add/',
        '/MDMT/Beneficiary/Verify/',

        '/AD_SenderSearch',
        '/AD_SenderAdd',
        '/AD_SenderVerify',
        '/AD_BeneficiaryAdd',
        '/AD_BeneficiaryVerify',

        '/EDMT/Transfer',
        '/EDMT/Sender',
        '/EDMT/Sender/Search',
        '/EDMT/Sender/Add',
        '/EDMT/Sender/Verify',
        '/EDMT/Beneficiary/Add/',
        '/EDMT/Beneficiary/Verify/',
        '/EDMT/Beneficiary/Delete/',

        '/PDMT/Transfer',
        '/PDMTSender',
        '/PDMTSender/Search',
        '/PDMTSender/Add',
        '/PDMTSender/Verify',
        '/PDMTBeneficiaryAdd/',
        '/PDMTBeneficiary/Verify/',

        '/ICashDMT/Transfer',
        '/ICashDMT/Sender',
        '/ICashDMT/Sender/Search',
        '/ICashDMT/Sender/Add',
        '/ICashDMT/Sender/Verify',
        '/ICashDMT/Beneficiary/Add/',
        '/ICashDMT/Beneficiary/Verify/',

        '/OB_Sender',
        '/OB_SenderAdd',
        '/OB_SenderVerify',
        '/OB_BeneficiaryAdd',
        '/OB_BeneficiaryVerify',

        //CommonDMTAsPayout
        '/SenderAdd',
        '/SenderVerify',
        '/BeneAdd',
        '/SenderSearch',
        '/C_SenderSearch',
        '/BeneVerify',

        // EzyPay
        '/EZPSenderSearch',
        '/EZPSenderAdd',
        '/EZPSenderVerify',
        '/EZPBeneficiaryAdd',
        '/EZPBeneficiaryVerify',

        //EzyPayV1
        '/EZPV1SenderSearch',
        '/EZPV1SenderAdd',
        '/EZPV1_GenerateSenderOTP',
        '/EZPV1_VerifySenderOTP',
        '/EZPV1_SenderAuthentication',
        '/EZPV1_SplitAmount',
        '/EZPV1SenderVerify',
        '/EZPV1BeneficiaryAdd',
        '/EZPV1_TransactionConfirmation',
        '/EZPV1BeneficiaryVerify',

        //NSDLDMT
        '/NBDMT_SenderSearch',
        '/NBDMT_SenderOnboard',
        '/NBDMT_GenerateOTP',
        '/NBDMT_VerifySenderOTP',
        '/NBDMT_SenderAuthentication',
        '/NBDMT_BeneficiaryAdd',
        '/NBDMT_SplitAmount',

        //OnlyAPIDMT
        '/OADMT_SenderSearch',
        '/OADMT_SenderOnboard',
        '/OADMT_GenerateOTP',
        '/OADMT_VerifySenderOTP',
        '/OADMT_SenderAuthentication',
        '/OADMT_BeneficiaryAdd',
        '/OADMT_SplitAmount',

        //PayPoint
        '/PPISenderAdd',
        '/PPIGenerateAadharOTP',
        '/PPIVerifyAadharOTP',
        '/PPIVerifySenderOTP',
        '/PPIPanCardKYC',
        '/PPIBeneDeleteOTP',
        '/PPIBeneficiaryAdd',
        '/PPIBenificiaryList',
        '/PPI_TransactionConfirmation',
        '/PPIBeneficiaryVerify',

        //PaySprintPPI
        '/PS_PPIAgentRegistration',
        '/PS_PPIRedirectURL',

        // EzyPaytmPay
        '/EZPTMSenderSearch',
        '/EZPTMSenderAdd',
        '/EZPTMSenderVerify',
        '/EZPTMBeneficiaryAdd',
        '/EZPTMBeneficiaryVerify',

        //InstantPay
        '/I_SenderSearch',
        '/I_SenderAdd',
        '/I_SenderVerify',
        '/I_BeneficiaryAdd',
        '/I_BeneficiaryDelete',

        //PayU
        '/PU_SenderSearch',
        '/PU_SenderAdd',
        '/PU_SenderVerify',
        '/PU_BeneficiaryAdd',
        '/PU_BeneficiaryVerify',

        //Paysprint
        '/PS_SenderSearch',
        '/PS_SenderAdd',
        '/PS_SenderAuthentication',
        '/PS_TransactionConfirmation',
        '/PS_SplitAmount',
        '/PS_BeneficiaryAdd',
        '/PS_SenderAadharVerifyBank2',
        '/PS_PSSenderEKYCBank2',

        //Casa
        '/CS_SenderSearch',
        '/CS_SenderAuthentication',
        '/CS_TransactionConfirmation',
        '/CS_SplitAmount',
        '/CS_BeneficiaryAdd',

        //Icicicomposite
        '/IC_SenderAdd',
        '/IC_SenderVerify',
        '/IC_BeneAdd',
        '/IC_SenderSearch',
        '/IC_BeneVerify',

        //RazorpayDMT
        '/RP_SenderAdd',
        '/RP_SenderVerify',
        '/RP_BeneAdd',
        '/RP_SenderSearch',
        '/RP_BeneVerify',

        //JaiJui
        '/JJ_SenderAdd',
        '/JJ_SenderVerify',
        '/JJ_BeneAdd',
        '/JJ_SenderSearch',
        '/JJ_BeneVerify',
        //InstantPayPayout
        '/IP_SenderAdd',
        '/IP_SenderVerify',
        '/IP_BeneAdd',
        '/IP_SenderSearch',
        '/IP_BeneVerify',

        //UPI
        '/UPISenderAdd',
        '/UPISenderSearch',
        '/UPISenderVerify',
        '/UPIBeneficiaryAdd',
        '/UPIBeneficiaryVerify',
        //PrimePay
        '/PP_SenderAdd',
        '/PP_SenderVerify',
        '/PP_BeneAdd',
        '/PP_SenderSearch',
        '/PP_BeneVerify',

        //Hypto
        '/H_SenderAdd',
        '/H_SenderVerify',
        '/H_BeneAdd',
        '/H_SenderSearch',
        '/H_BeneVerify',

        //Zplus Payout
        '/ZPP_SenderAdd',
        '/ZPP_SenderVerify',
        '/ZPP_BeneAdd',
        '/ZPP_SenderSearch',
        '/ZPP_BeneVerify',

        //Zplus
        '/ZP_DMTSenderSearch',
        '/ZP_SenderAdd',
        '/ZP_SenderVerify',
        '/ZP_BeneficiaryAdd',

        //CashFree
        '/CF_SenderAdd',
        '/CF_SenderVerify',
        '/CF_BeneAdd',
        '/CF_SenderSearch',
        '/CF_BeneVerify',

        //Ambika
        '/AB_SenderAdd',
        '/AB_SenderVerify',
        '/AB_BeneAdd',
        '/AB_SenderSearch',
        '/AB_BeneVerify',

        //Round Pay
        '/ROP_SenderAdd',
        '/ROP_SenderVerify',
        '/ROP_BeneAdd',
        '/ROP_BeneVerify',

        //M2M #ClareInfoTech
        '/CIT_SenderAdd',
        '/CIT_BeneAdd',
        '/CIT_SenderVerify',
        '/CIT_BeneVerify',
        '/CIT_BeneDeleteVerify',

        //VastWeb DMT
        '/VW_SenderAdd',
        '/VW_SenderVerify',
        '/VW_BeneAdd',

        //LevinDMT
        '/LF_SenderAdd',
        '/LF_SenderVerify',
        '/LF_BeneAdd',

        //IMPSGuru DMT
        '/IG_BeneAdd',
        '/IG_SenderAdd',

        //Eko
        '/Eko_SenderSearch',
        '/Eko_SenderAdd',
        '/Eko_SenderVerify',
        '/Eko_BeneficiaryAdd',
        '/Eko_BeneficiaryVerify',

        //PAYTM CCF
        '/PC_SenderSearch',
        '/PC_SenderAdd',
        '/PC_SenderVerify',
        '/PC_BeneficiaryAdd',
        '/PC_BeneficiaryVerify',
        '/PC_BeneficiaryDelete',

        //WhiteLabelPAYTM CCF
        '/WPC_SenderSearch',
        '/WPC_SenderAdd',
        '/WPC_BeneficiaryDelete',
        '/WPC_BeneficiaryAdd',
        '/WPC_BeneficiaryVerify',

        //Mahagram
        '/MG_SenderSearch',
        '/MG_SenderAdd',
        '/MG_SenderVerify',
        '/MG_BeneficiaryAdd',
        '/MG_BeneficiaryVerify',
        '/MG_BeneGetOTP',

        //MasterMoney
        '/MMoney_SenderSearch',
        '/MMoney_SenderAdd',
        '/MMoney_BeneficiaryAdd',

        '/CDMT_Transfer',
        '/CDMT_Sender',
        '/CDMT_SenderSearch',
        '/CDMT_SenderAdd',
        '/CDMT_SenderVerify',
        '/CDMT_BeneficiaryAdd',
        '/CDMT_BeneficiaryVerify',
        '/CDMT_BeneficiaryDelete',

        //MyNetLink

        '/MNLDMT_Transfer',
        '/MNLDMTSender',
        '/MNLDMTSender_Search',
        '/MNLDMTSender_Add',
        '/MNLDMTBeneficiaryAdd',

        //Novity5L
        '/NT5LDMT_SenderSearch',
        '/NT5LDMT_AgentRegistration',
        '/NT5LDMT_SenderAdd',
        '/NT5LDMT_BeneVerify',
        '/NT5LDMT_SenderVerify',
        '/NT5LDMT_BeneficiaryAdd',
        '/NT5LDMT_BeneDeleteVerify',

        //Novity Common
        '/NTDMT_SenderSearch',
        '/NTDMT_SenderAdd',
        '/NTDMT_SenderVerify',
        '/NTDMT_BeneficiaryAdd',
        '/NTDMT_BeneficiaryVerify',
        '/NTDMT_AgentRegistration',
        '/NTDMT_BeneVerify',
        '/NTDMT_BeneDeleteVerify',
        '/NTDMT_GenerateSenderOTP',
        '/NTDMT_SenderEKYC',
        '/NTDMT_TransactionConfirmation',
        '/NTDMT_SplitAmount',
        '/NTDMT_AirtelBankSenderAdd',
        '/NTDMT_AirtelBankSenderVerify',
        '/NTDMT_AirtelSenderEKYC',
        '/NTDMT_NSDLBank3SenderAdharVerifyEKYC',
        '/NTDMT_NSDLBankSenderAdd',
        '/NTDMT_NSDLBankSenderOTPVerify',

        //KYC PPI same as DMT
        '/KYCPPI_SenderRegistration',
        '/KYCPPI_SenderVerify',
        '/KYCPPI_SenderSearch',
        '/KYCPPI_SendereKYC',
        '/KYCPPI_BeneAdd',
        '/KYCPPI_TransactionConfirmation',
        '/KYCPPI_SplitAmount',

        '/OperatorWiseUserWiseReport',
        '/UserReferralReport',
        '/ReferredUserReport',
        '/ReferAndEarn',
        '/PSLeadGeneration',
        '/IPGTransaction',
        '/PaymentGatewayTransaction',
        '/CreditCardToBank',
        '/CheckCIBILScore',
        '/PGSuccess',
        '/PGFail',
        '/RTransaction',
        '/PaymentGatewayReport',
        '/PTransaction',
        '/CTransaction',
        '/RazorpayQRTransaction',
        '/IMoneyPayPG',
        '/PayGoalPG',
        '/UPIGatewayTransaction',
        '/PaymentGatewayLog',
        '/FPAEPS',
        '/OCAEPS',
        '/IPRegistrationOTP',
        '/IPRegistration',
        '/EkoUserOnbording',
        '/IPChangeMobile',
        '/IPChangeMoblieVerify',
        '/QRCodeGenerate',
        '/DMTReport',
        '/PPIReport',
        '/ResponseAdd',
        '/Daybook',
        '/Daybook/Report',
        '/AEPSReport',
        '/MicroATMReport',
        '/POSReport',
        '/IPAdd',
        '/CallbackAdd',
        '/Log',
        '/Log/Report',
        '/ApiUserLog',
        '/CallbackMaster/Edit',
        '/CommissionStructure',
        '/KeySetting',
        '/KeyEdit',
        '/SMSAdd',
        '/MessageSetting',
        '/WebHookSetting',
        '/CashCollection',
        '/CashCollectionAdd',
        '/CashCollectionReverse',
        '/CashCollectionReport',
        '/CashDepositReport',
        '/BankStatement',
        '/PayoutBulkTransfer',
        '/Complaints',
        '/IDPurchaseReport',
        '/AddBank',
        '/VirtualBalance',
        '/VirtualBalance/Add',
        '/SmsReport',
        '/OperatorUserwise',
        '/OperatorWiseViewProvider',
        '/UserwiseServiceCharge',
        '/ServiceSubscriptionCharge',
        '/PendingSubcriptionCharge',
        '/SubscriptionChargeReport',
        '/SubscriptionPaymentReport',
        '/GrowthLossReport',
        '/AccountStatementReport',
        '/SubscriptionPendingPayment',
        '/UserWiseBulkActionSDAndDist',
        '/SupportAccess',
        '/MainManuSubManuAccess',
        '/UserActionHistory',
        '/FundReverseRequestReport',
        '/Fund/ReverseRequest',
        '/Fund/ReverseTransferReport',
        '/ServiceChargeDeductionReport',
        '/CircleAPIAdd',
        '/WalletTransfer',
        '/SaleReport',
        '/LoginHistory',
        '/OperatorSale',
        '/Notification',
        '/Document',
        '/PlanApiDocument',
        '/WebViewDocument',
        '/LiveTransaction',
        '/DMTDocument',
        '/ADMTDocument',
        '/EkoDMTDocument',
        '/MDMTDocument',
        '/PDMTDocument',
        '/ICashDMTDocument',
        '/ICICI_CompositeDMTDocument',
        '/ICICI_CompositeDMTDoc',
        '/DMTAPIDocument',
        '/IDMTDocument',
        '/CDMTDocument',
        '/EDMTDocument',
        '/MahagramDMTDocument',
        '/PCCFDMTDocument',
        '/AEPSDocument',
        '/CFDMTDocument',
        '/CircleSwitching',
        '/UserToken',
        '/ProviderLog',
        '/WebHookLog',
        '/LapuReport',
        '/PendingIP',
        '/DMTPipeMaster',
        '/News/Index',
        '/XMPP/Status',
        '/EmailSetting',
        '/EmailSetting/Index',
        '/EmailSetting/Add',
        '/EmailSetting/Edit',
        '/DenominationDetails/Denomination',
        '/LiveTransaction',
        '/ReconciliationSettings',
        '/ReconciliationSettings/Index',
        '/ReconciliationSettings/Add',
        '/ReconciliationUpload',
        '/BBPSConfiguration',
        '/BBPSConfiguration/Add',
        '/BBPSConfiguration/Edit',
        '/BBPSConfiguration/Index',
        '/DMTSettings',
        '/DMTSettings/Index',
        '/PPISetting/Index',
        '/DematSetting',
        '/UPITransferSetting',
        '/AccountOpenSetting',
        '/UserWisePlanLimitSetting',
        '/LeadGeneration',
        '/CIBILScoreSetting/Index',
        '/AddBeneficiary',

        '/VerificationSettings',
        '/ThirdPartyServiceProvider',
        '/ThirdPartyServiceProvider/Index',
        '/ProviderFailure',
        '/PayoutReport',
        '/Slider',
        '/DenominationDetails/DenominationMapping',
        '/UserLedger',
        '/UserWiseServiceSellReport',
        '/AdminLedger',
        '/ChannelSlabs',
        '/ChannelSlabAssign',
        '/ChannelSlabs/AssignEdit',
        '/MenuAdd',
        '/CallMeRequest',
        '/PushNotifications',
        '/CallRequestReport',
        '/AddPurchase',
        '/ProviderDayBook',
        '/ProviderSale',
        '/AmountWiseInsights',
        '/BulkMessageIndex',
        '/Payout',
        '/InvoiceSettings',
        '/InvoiceSettings/Index',
        '/PaymentGateWaySetting',
        '/UserwisePaymentGateway',
        '/UPITransferReport',
        '/ProviderWisePerformanceGraph',
        '/OTTReport',
        '/BusBookingReport',
        '/AccountOpeningReport',
        '/CIBILScoreReport',
        '/AEPSSetting',
        '/MicroATMSetting',
        '/CyberPlateSettings',
        '/CyberPlateSettings/Index',
        '/Fund/GatewayTransaction',
        '/Invoice',
        '/GSTHold',
        '/GSTSummary',
        '/MAEPS',
        'Users/Inactive',
        '/RetailerDashboard',
        '/ClientDashboard',
        '/DistributorDashboard',
        '/SuperDistributorDashboard',

        '/KYCSetting',
        '/AdjustCommission',
        '/RangeWiseSequence',
        '/AccessDenied',
        '/EcollectionReport',
        '/ManualSuccessFailReport',
        '/PastSuccessFailReport',
        '/DownlineReport',
        '/Transaction/ThirdPartyService',
        '/UISetting',
        '/UserwiseSale',
        '/Company',
        '/EcollectionSetting',
        '/Ticket',
        '/TicketReport',
        '/Performance',
        '/OutsideRoleSetting',
        '/BalanceCapping',
        '/LapuAccounting',
        '/AdminAccounting',
        '/LapuMapping',
        '/LapuPurchase',
        '/LapuUsage',
        '/OfflineProduct',
        '/OfflineBook',
        '/OfflineBookReport',
        '/SubscriptionRenew',
        '/TwoFA',
        '/AgreementForm',
        '/AddVoucher',
        '/ApproveVoucher',
        '/CreditRequest',
        '/CreditRequestSetting',
        '/Outstanding',
        '/DistributerOutStandingDetailsReport',
        '/BalanceSheetReport',
        '/VoucherModeReport',
        '/ReportVoucher',
        '/VersionHistory',
        '/PrepaidActivation',
        '/PrepaidActivationReport',
        '/DigitalCertificateIndex',
        '/DenominationDetails',
        '/ServiceWiseSlider',
        '/VirtualAccountSetting',
        '/CircleIndex',
        '/UserwiseLowBalance',
        '/PlanSetting',
        '/DematGrowthLoss',
        '/CMSDMT',
        '/DMTBankSetting',
        '/SenderBeneficiaryReport',
        '/OverdraftReverse',
        '/OverdraftTransfer',
        '/OverdraftSetting',
        '/SeviceswiseWallet',
        '/DthCategoryChannel',
        '/DthPackageChannel',
        '/KYC/Approve',
        '/ChangeStatus',
        '/CommissionHold',
        '/CommissionHoldRequest',

        '/CommissionHoldReport',
        '/AutoBalanceTransfer',
        '/UserOnboardedReport',
        '/UserOnbordedStatusCheck',
        '/RetailerToAllFundTransfer',
        '/InstantPayeKYC',
        '/EnquiryReport',
        '/UserwiseSequenceIndex',
        '/UserwiseCircleIndex/UserWiseCircleAdd',
        '/UserwiseCircleIndex',
        '/CashCollectionReportV2',
        '/CircleWiseOperatorLimitAdd',
        '/OperatorLimitIndex',
        '/Slabs/CircleWiseCommission',
        '/EKYCSetting',
        '/CreditInstitutionSetting',
        '/KycIndex',
        '/VirtualAccountCreate',
        '/PanCardSetting',
        '/LeadGenerationSetting',
        '/OnlyAPILeadGeneration',
        '/PSPanCard',
        '/PanMitraPanCard',
        '/AddOperatorAmount',
        '/AddRemainderOperatorAmount',
        '/PaysprinteKYC',
        '/POSSetting',
        '/EkycPS',
        '/EkycCF',
        '/CMSInitiatePS',
        '/PSBusBooking',
        '/CMSReport',
        '/CF_UPITransferDocument',
        '/UPITransferAPIDocument',
        '/CP_UPITransferDocument',
        '/MNL_UPITransferDocument',
        '/CMSSetting',

        '/PaytmSenderSearch',
        '/AlleDMTSenderSearch',
        '/IPSenderSearch',
        '/MMoneySenderSearch',
        '/ESenderSearch',
        '/OpenBankSenderSearch',

        '/ICashSenderSearch',
        '/ICompositeSenderSearch',
        '/MahagramDMTSenderSearch',
        '/EkoDMTSenderSearch',
        '/AB_SenderSearch',
        '/ROP_DMTSenderSearch',
        '/CIT_DMTSenderSearch',
        '/VW_DMTSenderSearch',
        '/LF_DMTSenderSearch',
        '/IG_DMTSenderSearch',

        '/CDMTSenderSearch',
        '/Demat',
        '/DematReport',
        '/IndexMorePay',
        '/MP_UserOnboarding',
        '/MP_EKYOTP',
        //MM Pure DMT
        '/MMoneyPSenderSearch',
        '/MMoneyP_SenderSearch',
        '/MMoneyP_SenderAdd',
        '/MMoneyP_BeneficiaryAdd',
        '/MMoneyP_SenderVerify',
        '/PS_PanRedirectURL',
        '/PanMitraPanRedirectURL',
        '/DematRedirectURL',
        '/NSDLRedirectURL',
        '/DematLoginRedirect',
        '/PSCreateVPA',
        '/PSDynamicQR',
        '/PSStaticQR',
        '/RPCreateQR',
        '/UserCreationSetting',
        '/IDPurchase',
        '/FreeIDTransfer',
        '/ReporteKyc',
        '/SmartPayTransaction',
        '/VendorPayReport',
        '/UserWisePlanViewReport',
        '/OTTTransaction',
        '/LoanRedirect',
        '/Loan',
        '/EkycPD',
        '/SDKGenerateUrl',
        '/SDKURLRedirect',
        '/SDKUserMapping',
        '/EkycQU',
        '/GSTDetailsV2',
        '/PSAuthenticationManual',
        '/PSGetLocation',
        '/VleRegistration',
        '/CouponBuy',
        '/CPAuthentication',
        '/FPInitiate',
        '/PayUTransaction',
        '/ActionController',
        '/ViewBeneficiary',
        '/ViewOwnBeneficiary',
        '/AddOwnBeneficiary',
        '/MerchantOnboarding',
        '/OnboardingReport',
        '/OnlyAPIOnboarding',
        '/EditNSDLOnboarding',
        '/BulkOnboarding',
        '/OnlyAPIBulkOnboarding',
        '/BulkUpdateTIDMID',
    ];
    return (
        <Route path={RoutePath}>
            <InnerLayout>
                <InnerLayoutRoute
                    path="/PayUTransaction"
                    component={PayUTransaction}
                />
                <InnerLayoutRoute
                    path="/CPAuthentication"
                    exact
                    component={CredoPayAuthentication}
                />
                <InnerLayoutRoute
                    path="/CouponBuy"
                    exact
                    component={CouponBuy}
                />
                <InnerLayoutRoute
                    path="/VleRegistration"
                    exact
                    component={VleRegistration}
                />
                <InnerLayoutRoute
                    path="/PSAuthenticationManual"
                    exact
                    component={PaysprintAEPSAuthenticationManual}
                />
                <InnerLayoutRoute
                    path="/PSGetLocation"
                    exact
                    component={PaysprintAEPSGetLocation}
                />
                <InnerLayoutRoute path="/EkycQU" exact component={QuickeKYC} />
                <InnerLayoutRoute
                    path="/SDKUserMapping"
                    component={SDKUserMapping}
                />
                <InnerLayoutRoute
                    path="/SDKURLRedirect"
                    component={SDKURLRedirect}
                />
                <InnerLayoutRoute
                    path="/ActionController"
                    component={ActionController}
                />
                <InnerLayoutRoute
                    path="/MainManuSubManuAccess"
                    component={MainManuSubManuAccess}
                />
                <InnerLayoutRoute
                    path="/SDKGenerateUrl"
                    component={SDKGenerateUrl}
                />
                <InnerLayoutRoute path="/Loan" component={Loan} />
                <InnerLayoutRoute
                    path="/VendorPayReport"
                    component={VendorPayReport}
                />
                <InnerLayoutRoute
                    path="/UserWisePlanViewReport"
                    component={UserWisePlanViewReport}
                />
                <InnerLayoutRoute path="/ReporteKyc" component={ReporteKyc} />
                <InnerLayoutRoute
                    path="/FreeIDTransfer"
                    component={FreeIDTransfer}
                />
                <InnerLayoutRoute path="/IDPurchase" component={IDPurchase} />
                <InnerLayoutRoute
                    path="/UserCreationSetting"
                    component={UserCreationSetting}
                />
                <InnerLayoutRoute
                    path="/DematRedirectURL"
                    component={DematRedirectURL}
                />
                <InnerLayoutRoute
                    path="/NSDLRedirectURL"
                    component={NSDLRedirectURL}
                />
                <InnerLayoutRoute
                    path="/UserwiseAccounting"
                    component={UserwiseAccounting}
                />
                <InnerLayoutRoute
                    path="/DematLoginRedirect"
                    component={DematLoginRedirect}
                />
                <InnerLayoutRoute
                    path="/PS_PanRedirectURL"
                    component={PaysprintPanRedirectURL}
                />
                <InnerLayoutRoute
                    path="/PanMitraPanRedirectURL"
                    component={PanMitraRedirectURL}
                />
                <InnerLayoutRoute
                    exact
                    path="/MMoneyP_SenderVerify"
                    component={MMoneyPDMTSenderVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/MMoneyP_SenderSearch"
                    component={MMoneyPDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/MMoneyP_SenderAdd"
                    component={MMoneyPDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/MMoneyP_BeneficiaryAdd"
                    component={MMoneyPDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/MMoneyPSenderSearch"
                    exact
                    component={() => (
                        <MMoneyPSenderSearch ActiveDMTName="MasterMoneyPureDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/MP_UserOnboarding"
                    exact
                    component={UserOnboarding}
                />
                <InnerLayoutRoute path="/MP_EKYOTP" exact component={EKYCOTP} />
                <InnerLayoutRoute
                    path="/IndexMorePay"
                    exact
                    component={IndexMorePay}
                />
                <InnerLayoutRoute path="/Demat" exact component={Demat} />
                <InnerLayoutRoute
                    path="/DematReport"
                    exact
                    component={DematReport}
                />
                <InnerLayoutRoute
                    path="/CMSInitiatePS"
                    exact
                    component={PaySprintCMSInitiate}
                />
                <InnerLayoutRoute
                    path="/FPInitiate"
                    exact
                    component={FingpayInsuranceInitiate}
                />
                <InnerLayoutRoute
                    path="/PSBusBooking"
                    exact
                    component={PaySprintBusBooking}
                />
                <InnerLayoutRoute
                    path="/EkycPS"
                    exact
                    component={IndexPaysprint}
                />
                <InnerLayoutRoute
                    path="/EkycCF"
                    exact
                    component={IndexCashFree}
                />
                <InnerLayoutRoute
                    path="/EkycPD"
                    exact
                    component={PADRSAadhar}
                />
                <InnerLayoutRoute
                    path="/Slabs/CircleWiseCommission"
                    component={CircleWiseCommission}
                />
                <InnerLayoutRoute
                    path="/POSSetting"
                    exact
                    component={POSSetting}
                />
                <InnerLayoutRoute path="/KycIndex" exact component={KycIndex} />
                <InnerLayoutRoute
                    path="/VirtualAccountCreate"
                    exact
                    component={VirtualAccountCreate}
                />
                <InnerLayoutRoute
                    path="/PaysprinteKYC"
                    exact
                    component={PaysprinteKYC}
                />
                <InnerLayoutRoute
                    path="/InstantPayeKYC"
                    exact
                    component={InstantPayeKYC}
                />
                <InnerLayoutRoute
                    path="/AddOperatorAmount"
                    exact
                    component={AddOperatorAmount}
                />
                <InnerLayoutRoute
                    path="/AddRemainderOperatorAmount"
                    exact
                    component={AddRemainderOperatorAmount}
                />
                <InnerLayoutRoute
                    path="/EKYCSetting"
                    exact
                    component={EKYCSetting}
                />
                <InnerLayoutRoute
                    path="/CreditInstitutionSetting"
                    exact
                    component={CreditInstitutionSetting}
                />
                <InnerLayoutRoute
                    path="/OperatorLimitIndex"
                    exact
                    component={OperatorLimitIndex}
                />
                <InnerLayoutRoute
                    path="/CircleWiseOperatorLimitAdd"
                    exact
                    component={CircleWiseOperatorLimitAdd}
                />
                <InnerLayoutRoute
                    path="/CashCollectionReportV2"
                    exact
                    component={CashCollectionReportV2}
                />
                <InnerLayoutRoute
                    path="/UserwiseCircleIndex"
                    exact
                    component={UserwiseCircleIndex}
                />
                <InnerLayoutRoute
                    path="/UserwiseCircleIndex/UserWiseCircleAdd"
                    exact
                    component={UserWiseCircleAdd}
                />
                <InnerLayoutRoute
                    path="/EnquiryReport"
                    exact
                    component={EnquiryReport}
                />
                <InnerLayoutRoute
                    path="/CommissionHold"
                    exact
                    component={CommissionHold}
                />
                <InnerLayoutRoute
                    path="/AutoBalanceTransfer"
                    exact
                    component={AutoBalanceTransfer}
                />
                <InnerLayoutRoute
                    path="/APIAgentKYC"
                    exact
                    component={APIAgentKYC}
                />
                <InnerLayoutRoute
                    path="/EPayAEPSAuthentication"
                    exact
                    component={EzyPayAEPSAuthentication}
                />
                <InnerLayoutRoute
                    path="/EPayAEPS"
                    exact
                    component={EzyPayAEPS}
                />
                <InnerLayoutRoute
                    path="/EPayOnboardingForAirtel"
                    exact
                    component={EPayOnboardingForAirtel}
                />
                <InnerLayoutRoute
                    path="/RetailerToAllFundTransfer"
                    exact
                    component={RetailerToAllFundTransfer}
                />
                <InnerLayoutRoute
                    path="/CommissionHoldRequest"
                    exact
                    component={CommissionHoldRequest}
                />
                <InnerLayoutRoute
                    path="/CommissionHoldReport"
                    exact
                    component={CommissionHoldReport}
                />
                <InnerLayoutRoute
                    path="/ProviderCommission"
                    exact
                    component={ProviderCommission}
                />
                <InnerLayoutRoute
                    path="/ProviderStateConfigSetup"
                    exact
                    component={ProviderStateConfigSetup}
                />
                <InnerLayoutRoute
                    path="/ChangeStatus"
                    exact
                    component={ChangeStatus}
                />
                <InnerLayoutRoute
                    path="/DthPackageChannel"
                    exact
                    component={DthPackageChannel}
                />
                <InnerLayoutRoute
                    path="/PCreditCardPayment"
                    exact
                    component={PaysprintCreditCardPayment}
                />
                <InnerLayoutRoute
                    path="/PUCreditCardPayment"
                    exact
                    component={PayUCreditCard}
                />
                <InnerLayoutRoute
                    path="/CFCreditCardPayment"
                    exact
                    component={CashfreeCreditCard}
                />
                <InnerLayoutRoute
                    path="/MkCreditCardPayment"
                    exact
                    component={MobikwikCreditCard}
                />
                <InnerLayoutRoute
                    path="/IPCreditCardPayment"
                    exact
                    component={InstantPayCreditCard}
                />
                <InnerLayoutRoute
                    path="/C_CreditCardPayment"
                    exact
                    component={CommonCreditCard}
                />
                <InnerLayoutRoute
                    path="/EAEPS_SenderAdd"
                    exact
                    component={EkoAEPSSenderAdd}
                />
                <InnerLayoutRoute
                    path="/EAEPS_SenderVerify"
                    exact
                    component={EkoAEPSenderVerify}
                />
                <InnerLayoutRoute
                    path="/DthCategoryChannel"
                    exact
                    component={DthCategoryChannel}
                />
                <InnerLayoutRoute path="/TDS" exact component={TDSReport} />
                <InnerLayoutRoute
                    path="/RPAEPS"
                    exact
                    component={RapiPayAEPS}
                />
                <InnerLayoutRoute
                    path="/GSTReport"
                    exact
                    component={GSTReport}
                />
                <InnerLayoutRoute
                    path="/GSTDetails"
                    exact
                    component={GSTDetails}
                />
                <InnerLayoutRoute
                    path="/GSTDetailsV2"
                    exact
                    component={GSTDetailsV2}
                />
                <InnerLayoutRoute
                    path="/OverdraftSetting"
                    exact
                    component={OverdraftSetting}
                />
                <InnerLayoutRoute
                    path="/CashDepositSetting"
                    exact
                    component={CashDepositSetting}
                />
                <InnerLayoutRoute
                    path="/OverdraftTransfer"
                    exact
                    component={OverdraftTransferReport}
                />
                <InnerLayoutRoute
                    path="/OverdraftReverse"
                    exact
                    component={OverdraftReverseReport}
                />
                <InnerLayoutRoute
                    path="/OverdraftRequest"
                    exact
                    component={OverdraftRequest}
                />
                <InnerLayoutRoute
                    path="/OverdraftRequestReport"
                    exact
                    component={OverdraftRequestIndex}
                />
                <InnerLayoutRoute
                    path="/UserwiseLowBalance"
                    exact
                    component={UserwiseLowBalance}
                />
                <InnerLayoutRoute
                    path="/CMSDMT"
                    exact
                    component={CMSTransaction}
                />
                <InnerLayoutRoute
                    path="/PlanSetting"
                    exact
                    component={PlanSetting}
                />
                <InnerLayoutRoute
                    path="/DematGrowthLoss"
                    exact
                    component={DematGrowthLoss}
                />
                <InnerLayoutRoute
                    path="/OperatorWiseGST"
                    exact
                    component={OperatorWiseGST}
                />
                <InnerLayoutRoute
                    path="/PurchaseReport"
                    exact
                    component={PurchaseReport}
                />
                <InnerLayoutRoute
                    path="/ServiceWiseSlider"
                    exact
                    component={ServiceWiseSliderIndex}
                />
                <InnerLayoutRoute
                    path="/VirtualAccountSetting"
                    exact
                    component={VirtualAccountSetting}
                />
                <InnerLayoutRoute
                    path="/SubscriptionRenew"
                    exact
                    component={SubscriptionRenew}
                />
                <InnerLayoutRoute
                    path="/UPIDocument"
                    exact
                    component={UPIDocument}
                />
                <InnerLayoutRoute
                    path="/WalletTopUpIndex"
                    exact
                    component={WalletTopUpIndex}
                />
                <InnerLayoutRoute
                    path="/PSWalletTopUp"
                    exact
                    component={PaysprintWalletTopUp}
                />
                <InnerLayoutRoute
                    path="/WalletTopUpReport"
                    exact
                    component={WalletTopUpReport}
                />
                <InnerLayoutRoute
                    path="/SeviceswiseWallet"
                    exact
                    component={SeviceswiseWallet}
                />
                <InnerLayoutRoute
                    path="/MRegistration"
                    exact
                    component={MahagramRegistration}
                />
                <InnerLayoutRoute
                    path="/CFTransaction"
                    exact
                    component={CashFreeTransaction}
                />
                <InnerLayoutRoute
                    path="/DenominationDetails"
                    exact
                    component={DenominationDetails}
                />
                <InnerLayoutRoute
                    path="/PrepaidActivation"
                    exact
                    component={PrepaidActivation}
                />
                <InnerLayoutRoute
                    path="/DigitalCertificateIndex"
                    exact
                    component={DigitalCertificateIndex}
                />
                <InnerLayoutRoute
                    path="/PrepaidActivationReport"
                    exact
                    component={PrepaidActivationReport}
                />
                <InnerLayoutRoute path="/TwoFA" exact component={TwoFA} />
                <InnerLayoutRoute
                    path="/AgreementForm"
                    exact
                    component={AgreementForm}
                />
                <InnerLayoutRoute
                    path="/VersionHistory"
                    exact
                    component={VersionHistory}
                />
                <InnerLayoutRoute
                    path="/LapuUsage"
                    exact
                    component={LapuUsage}
                />
                <InnerLayoutRoute
                    path="/OfflineBookReport"
                    exact
                    component={OfflineBookReport}
                />
                <InnerLayoutRoute
                    path="/OfflineBook"
                    exact
                    component={OfflineBook}
                />
                <InnerLayoutRoute
                    path="/LapuPurchase"
                    exact
                    component={LapuPurchase}
                />
                <InnerLayoutRoute
                    path="/AdminAccounting"
                    exact
                    component={AdminAccounting}
                />
                <InnerLayoutRoute
                    path="/PanCardSetting"
                    exact
                    component={PanCardSetting}
                />
                <InnerLayoutRoute
                    path="/LeadGenerationSetting"
                    exact
                    component={LeadGenerationSetting}
                />
                <InnerLayoutRoute
                    path="/CMSSetting"
                    exact
                    component={CMSSetting}
                />
                <InnerLayoutRoute
                    path="/PanCardIndex"
                    exact
                    component={PanCardIndex}
                />
                <InnerLayoutRoute
                    path="/BusBookingIndex"
                    exact
                    component={BusBookingIndex}
                />
                <InnerLayoutRoute
                    path="/CPAEPS"
                    exact
                    component={CredoPayAEPS}
                />
                <InnerLayoutRoute
                    path="/LeadGenerationIndex"
                    exact
                    component={LeadGenerationIndex}
                />
                <InnerLayoutRoute
                    path="/PSPanCard"
                    exact
                    component={PaysprintPanCardGenerateURL}
                />
                <InnerLayoutRoute
                    path="/PanMitraPanCard"
                    exact
                    component={PanMitraPanCreation}
                />
                <InnerLayoutRoute
                    path="/PSLeadGeneration"
                    exact
                    component={PaysprintLeadGenerationGenerateURL}
                />
                <InnerLayoutRoute
                    path="/OfflineProduct"
                    exact
                    component={OfflineProduct}
                />
                <InnerLayoutRoute
                    path="/LapuAccounting"
                    exact
                    component={LapuAccounting}
                />
                <InnerLayoutRoute
                    path="/LapuMapping"
                    exact
                    component={LapuMapping}
                />
                <InnerLayoutRoute
                    path="/OutsideRoleSetting"
                    exact
                    component={OutsideRoleSetting}
                />
                <InnerLayoutRoute
                    path="/Performance"
                    exact
                    component={NPerformance}
                />
                <InnerLayoutRoute path="/Company" exact component={Company} />
                <InnerLayoutRoute
                    path="/UISetting"
                    exact
                    component={UISetting}
                />
                <InnerLayoutRoute
                    path="/DownlineReport"
                    exact
                    component={DownlineReport}
                />
                <InnerLayoutRoute
                    path="/ManualSuccessFailReport"
                    exact
                    component={ManualSuccessFailReport}
                />
                <InnerLayoutRoute
                    path="/PastSuccessFailReport"
                    exact
                    component={PastSuccessFailReport}
                />
                <InnerLayoutRoute
                    path="/EcollectionReport"
                    exact
                    component={EcollectionReport}
                />
                <InnerLayoutRoute
                    path="/PendingDmt"
                    exact
                    component={PendingDmt}
                />
                <InnerLayoutRoute
                    path="/PendingUPI"
                    exact
                    component={PendingUPI}
                />
                <InnerLayoutRoute
                    path="/AdjustCommission"
                    exact
                    component={AdjustCommission}
                />
                <InnerLayoutRoute
                    path="/RangeWiseSequence"
                    exact
                    component={RangeWiseSequence}
                />
                <InnerLayoutRoute
                    path="/AccessDenied"
                    exact
                    component={AccessDenied}
                />
                <InnerLayoutRoute
                    path="/CashDepositIndex"
                    exact
                    component={CashDepositIndex}
                />
                <InnerLayoutRoute
                    path="/PanCardReport"
                    exact
                    component={PanCardReport}
                />
                <InnerLayoutRoute
                    path="/LeadGenerationReport"
                    exact
                    component={LeadGenerationReport}
                />
                <InnerLayoutRoute
                    path="/ManualLeadGenerationReport"
                    exact
                    component={ManualLeadGenerationReport}
                />
                <InnerLayoutRoute
                    path="/PaidBillPaymentMasterReport"
                    exact
                    component={PaidBillPaymentMasterReport}
                />
                <InnerLayoutRoute
                    path="/UserOnboardedReport"
                    exact
                    component={UserOnbordedReport}
                />
                <InnerLayoutRoute
                    path="/UserOnbordedStatusCheck"
                    exact
                    component={UserOnbordedStatusCheck}
                />
                <InnerLayoutRoute
                    path="/KYCSetting"
                    exact
                    component={KYCSetting}
                />
                <InnerLayoutRoute
                    path="/RetailerDashboard"
                    exact
                    component={RetailerDashboard}
                />
                <InnerLayoutRoute
                    path="/ClientDashboard"
                    exact
                    component={RetailerDashboard}
                />
                <InnerLayoutRoute
                    path="/DistributorDashboard"
                    exact
                    component={DistributorDashboardV2}
                />
                <InnerLayoutRoute
                    path="/SuperDistributorDashboard"
                    exact
                    component={DistributorDashboardV2}
                />
                <InnerLayoutRoute
                    path="/ReconciliationUpload"
                    exact
                    component={ReconciliationUpload}
                />
                <InnerLayoutRoute
                    path="/ReconciliationSettings"
                    exact
                    component={ReconciliationSettings}
                />
                <InnerLayoutRoute
                    path="/ReconciliationSettings/Add"
                    component={ReconciliationSettingsAdd}
                />
                <InnerLayoutRoute
                    path="/ReconciliationSettings/Edit"
                    component={ReconciliationSettingsEdit}
                />
                <InnerLayoutRoute
                    path="/AdminDashboard"
                    exact
                    component={AdminDashboardV2}
                />
                <InnerLayoutRoute path="/Search" exact component={Search} />
                <InnerLayoutRoute
                    path="/RetailerSearch"
                    exact
                    component={RetailerSearch}
                />
                <InnerLayoutRoute
                    path="/ClientSearch"
                    exact
                    component={RetailerSearch}
                />
                <InnerLayoutRoute
                    path="/Pending"
                    exact
                    component={PendingRecharge}
                />
                <InnerLayoutRoute
                    path="/PendingProviderRecharge"
                    exact
                    component={PendingProviderRecharge}
                />
                <InnerLayoutRoute
                    path="/DMTResendWallet"
                    exact
                    component={DMTResendWallet}
                />
                <InnerLayoutRoute
                    path="/RangewiseDMT"
                    exact
                    component={RangewiseDMT}
                />
                <InnerLayoutRoute
                    path="/UserWiseDMTRangeReport"
                    exact
                    component={UserWiseDMTRangeReport}
                />
                <InnerLayoutRoute
                    path="/RangeWiseRecharge"
                    exact
                    component={RangeWiseRecharge}
                />
                <InnerLayoutRoute
                    path="/PSCashDepositPayment"
                    exact
                    component={PaysprintCashDeposit}
                />
                <InnerLayoutRoute
                    path="/FPCashDepositPayment"
                    exact
                    component={FingpayCashDeposit}
                />
                <InnerLayoutRoute
                    path="/Recharge"
                    exact
                    component={ActiveReport}
                />
                <InnerLayoutRoute
                    path="/ROfferRechargeReport"
                    exact
                    component={ROfferRechargeReport}
                />
                <InnerLayoutRoute
                    path="/TransactionDetail"
                    exact
                    component={TransactionDetailReport}
                />
                <InnerLayoutRoute
                    path="/AccountStatement"
                    component={TransactionDetailReport}
                />
                <InnerLayoutRoute
                    exact
                    path="/Fund"
                    component={FundRequestIndex}
                />
                <InnerLayoutRoute
                    path="/Fund/Request"
                    exact
                    component={Request}
                />
                <InnerLayoutRoute
                    path="/Fund/Transfer"
                    exact
                    component={Transfer}
                />
                <InnerLayoutRoute
                    path="/FundReverse"
                    exact
                    component={Reverse}
                />
                <InnerLayoutRoute
                    path="/Fund/Report"
                    component={FundTransferReport}
                />
                <InnerLayoutRoute
                    path="/PayoutSetting"
                    exact
                    component={PayoutSetting}
                />
                <InnerLayoutRoute
                    path="/RegisterComplaint"
                    exact
                    component={RegisterComplaint}
                />
                <InnerLayoutRoute
                    path="/ComplaintStatus"
                    exact
                    component={ComplaintStatus}
                />
                <InnerLayoutRoute
                    path="/Transaction"
                    exact
                    component={Transaction}
                />
                <InnerLayoutRoute
                    path="/BharatConnectTransactions"
                    exact
                    component={BBPSTransaction}
                />
                <InnerLayoutRoute
                    path="/DMTTransaction"
                    exact
                    component={() => <DMTTransaction isDMTOne="Yes" />}
                />
                <InnerLayoutRoute
                    path="/DMTTransaction2"
                    exact
                    component={() => <DMTTransaction isDMTOne="No" />}
                />
                <InnerLayoutRoute
                    path="/PPITransaction"
                    exact
                    component={() => <PPITransaction />}
                />
                <InnerLayoutRoute
                    path="/CreditInstitutionIndex"
                    exact
                    component={() => <CreditInstitutionIndex />}
                />
                <InnerLayoutRoute
                    path="/AddAndManageBeneficiary"
                    exact
                    component={AddAndManageBeneficiary}
                />
                <InnerLayoutRoute
                    path="/BankToOtherTransfer"
                    exact
                    component={BankToOtherTransfer}
                />
                <InnerLayoutRoute
                    path="/BankToBankTransfer"
                    exact
                    component={BankToBankTransfer}
                />
                <InnerLayoutRoute
                    path="/SelfTransfer"
                    exact
                    component={SelfTransfer}
                />
                <InnerLayoutRoute
                    path="/OtherBankBeneficiary"
                    exact
                    component={OtherBankBeneficiary}
                />
                <InnerLayoutRoute
                    path="/OwnBankBeneficiary"
                    exact
                    component={OwnBankBeneficiary}
                />
                <InnerLayoutRoute
                    path="/UPITransfer"
                    exact
                    component={UPITransfer}
                />
                <InnerLayoutRoute
                    path="/CM_UPITransfer"
                    exact
                    component={CommonUPITransfer}
                />
                <InnerLayoutRoute
                    path="/TransferUPI"
                    exact
                    component={TransferUPI}
                />
                <InnerLayoutRoute
                    path="/MNL_UPITransfer"
                    exact
                    component={MyNetLinkUPITransfer}
                />
                <InnerLayoutRoute
                    path="/CP_UPITransfer"
                    exact
                    component={ClickPayUPITransfer}
                />
                <InnerLayoutRoute
                    path="/AccountOpening"
                    exact
                    component={AccountOpeningIndex}
                />
                <InnerLayoutRoute path="/NSDLUrl" exact component={NSDL} />
                <InnerLayoutRoute
                    path="/LoanDistributor/CheckCustomer"
                    exact
                    component={CheckCustomer}
                />
                <InnerLayoutRoute
                    path="/LoanDistributor/CustomerRegistration"
                    exact
                    component={CustomerRegistration}
                />
                <InnerLayoutRoute
                    path="/LoanDistributor/LoginCustomer"
                    exact
                    component={LoginCustomer}
                />
                <InnerLayoutRoute
                    path="/LoanDistributor/CibilDetails"
                    exact
                    component={CibilDetails}
                />
                <InnerLayoutRoute path="/OTTIndex" exact component={OTTIndex} />
                <InnerLayoutRoute
                    path="/PS_AccountOpen"
                    exact
                    component={PaysprintAccountOpen}
                />
                <InnerLayoutRoute
                    path="/UserOnbording"
                    exact
                    component={UserOnbording}
                />
                <InnerLayoutRoute
                    path="/AEPSIndex"
                    exact
                    component={AEPSIndex}
                />
                <InnerLayoutRoute
                    path="/CreditCardSetting"
                    exact
                    component={CreditCardSetting}
                />
                <InnerLayoutRoute
                    path="/CreditCardPaymentIndex"
                    exact
                    component={CreditCardPaymentIndex}
                />
                <InnerLayoutRoute path="/PAEPS" exact component={PaytmAEPS} />
                <InnerLayoutRoute path="/AlleAEPS" exact component={AlleAEPS} />
                <InnerLayoutRoute
                    path="/EPayOnboarding"
                    exact
                    component={EzyPayOnboarding}
                />
                <InnerLayoutRoute
                    path="/PaysprintURLRedirect"
                    exact
                    component={PaysprintURLRedirect}
                />
                <InnerLayoutRoute
                    path="/PSAEPS"
                    exact
                    component={PaysprintAEPS}
                />
                <InnerLayoutRoute
                    path="/PSAEPSAuthentication"
                    exact
                    component={PaysprintAEPSAuthentication}
                />
                <InnerLayoutRoute
                    path="/OCAEPS"
                    exact
                    component={OneClickAEPS}
                />
                <InnerLayoutRoute
                    path="/OCUserOnbording"
                    component={OneClickUserOnbording}
                />

                <InnerLayoutRoute
                    path="/OCAuthentication"
                    exact
                    component={OneClickTwoFactorAuthentication}
                />
                <InnerLayoutRoute
                    path="/OCValidateOTP"
                    component={OneClickValidateOTP}
                />
                <InnerLayoutRoute
                    path="/OCSendOTP"
                    component={OneClickSendOTP}
                />
                <InnerLayoutRoute
                    path="/OCBiomatric"
                    component={OneClickBiomatric}
                />
                <InnerLayoutRoute
                    path="/FPAEPS"
                    exact
                    component={FingpayAEPS}
                />
                <InnerLayoutRoute
                    path="/FPUserOnbording"
                    component={FingPayUserOnbording}
                />
                <InnerLayoutRoute
                    path="/FPAuthentication"
                    exact
                    component={FingPayTwoFactorAuthentication}
                />
                <InnerLayoutRoute
                    path="/FPSendOTP"
                    component={FingpaySendOTP}
                />
                <InnerLayoutRoute
                    path="/FPValidateOTP"
                    component={FingpayValidateOTP}
                />
                <InnerLayoutRoute
                    path="/FPBiomatric"
                    component={FingPayBiomatric}
                />
                <InnerLayoutRoute
                    path="/ACAEPS"
                    exact
                    component={ApiClubAEPS}
                />
                <InnerLayoutRoute
                    path="/ACUserOnbording"
                    component={ApiClubUserOnbording}
                />
                <InnerLayoutRoute
                    path="/ACSendOTP"
                    component={ApiClubSendOTP}
                />
                <InnerLayoutRoute
                    path="/ACValidateOTP"
                    component={ApiClubValidateOTP}
                />
                <InnerLayoutRoute
                    path="/ACBiomatric"
                    component={ApiClubBiomatric}
                />
                <InnerLayoutRoute
                    path="/PSOnbording"
                    exact
                    component={PaysprintUserOnbording}
                />
                <InnerLayoutRoute
                    path="/PSAuthentication"
                    exact
                    component={PaysprintAuthentication}
                />
                <InnerLayoutRoute
                    path="/CSOnbording"
                    exact
                    component={CasaUserOnbording}
                />

                <InnerLayoutRoute
                    path="/PSPOnbording"
                    exact
                    component={PaysprintPaytmOnboarding}
                />
                <InnerLayoutRoute
                    path="/PSPAEPS"
                    exact
                    component={PaysprintPaytmAEPS}
                />
                <InnerLayoutRoute
                    path="/PSPAEPSAuthentication"
                    exact
                    component={PaysprintPaytmAEPSAuthentication}
                />
                <InnerLayoutRoute
                    path="/IPMOnbording"
                    exact
                    component={InstantPayMerchantOnboarding}
                />
                <InnerLayoutRoute
                    path="/IPAEPS"
                    exact
                    component={InstantPayAEPS}
                />
                <InnerLayoutRoute
                    path="/IPAEPSAuthentication"
                    exact
                    component={InstantPayAEPSAuthentication}
                />

                <InnerLayoutRoute
                    path="/NBAEPS"
                    exact
                    component={NSDLBankAEPS}
                />
                <InnerLayoutRoute
                    path="/NBAEPSAuthentication"
                    exact
                    component={NSDLBankAEPSAuthentication}
                />
                <InnerLayoutRoute
                    path="/NBAEPSTerminalRegister"
                    exact
                    component={NSDLBankAEPSTerminalRegister}
                />

                <InnerLayoutRoute
                    path="/OAAEPS"
                    exact
                    component={OnlyApiAEPS}
                />
                <InnerLayoutRoute
                    path="/OAAEPSAuthentication"
                    exact
                    component={OnlyApiAEPSAuthentication}
                />
                <InnerLayoutRoute
                    path="/OAAEPSTerminalRegister"
                    exact
                    component={OnlyApiAEPSTerminalRegistration}
                />
                <InnerLayoutRoute
                    path="/EAgentActivation"
                    component={EkoAgentActivation}
                />
                <InnerLayoutRoute
                    path="/Transaction/ThirdPartyService"
                    component={InstaProvider}
                />
                <InnerLayoutRoute
                    path="/MAEPS"
                    exact
                    component={MahagramAEPS}
                />
                <InnerLayoutRoute
                    path="/CashDepositReport"
                    exact
                    component={CashDepositReport}
                />
                <InnerLayoutRoute
                    path="/BankStatement"
                    exact
                    component={AccountStatement}
                />
                <InnerLayoutRoute
                    path="/PayoutBulkTransfer"
                    exact
                    component={PayoutBulkTransfer}
                />
                <InnerLayoutRoute path="/EAEPS" exact component={EkoAEPS} />
                <InnerLayoutRoute path="/KYC" exact component={Upload} />
                <InnerLayoutRoute path="/KYC/Upload" component={Upload} />
                <InnerLayoutRoute path="/KYC/Approve" component={Approve} />
                <InnerLayoutRoute exact path="/Users" component={Users} />
                <InnerLayoutRoute
                    exact
                    path="/CreditCardReport"
                    component={CreditCardPaymentReport}
                />
                <InnerLayoutRoute
                    path="/Users/Approve"
                    component={KYCApprove}
                />
                <InnerLayoutRoute
                    path="/Users/UserAlias"
                    component={UserAlias}
                />
                <InnerLayoutRoute path="/Users/Add" component={UserAdd} />
                <InnerLayoutRoute
                    path="/Users/DatewiseReport"
                    component={DatewiseUserReport}
                />
                <InnerLayoutRoute path="/Users/Edit" component={UserEdit} />
                <InnerLayoutRoute
                    path="/UsersProfile"
                    component={SelectProfile}
                />
                <InnerLayoutRoute
                    path="/Users/ChangePassword"
                    component={UpdatePassword}
                />
                <InnerLayoutRoute path="/Users/Index" component={Users} />
                <InnerLayoutRoute
                    path="/Users/DeletedUsers"
                    exact
                    component={DeletedUsers}
                />
                <InnerLayoutRoute
                    path="/Users/UserTransfer"
                    exact
                    component={UserTransfer}
                />
                <InnerLayoutRoute
                    path="/Users/UserwiseSaleTarget"
                    component={UserwiseSaleTarget}
                />
                <InnerLayoutRoute
                    path="/Users/UserwiseSaleTargetReport"
                    component={UserwiseSaleTargetReport}
                />
                <InnerLayoutRoute exact path="/Services" component={Services} />
                <InnerLayoutRoute path="/Services/Index" component={Services} />
                <InnerLayoutRoute
                    path="/Operators"
                    exact
                    component={Operators}
                />
                <InnerLayoutRoute
                    path="/Operators/Index"
                    component={Operators}
                />
                <InnerLayoutRoute
                    path="/Operators/Add"
                    component={OperatorAdd}
                />
                <InnerLayoutRoute
                    path="/Operators/Edit"
                    component={OperatorEdit}
                />
                <InnerLayoutRoute path="/Operators/HLR" exact component={HLR} />
                <InnerLayoutRoute
                    path="/Operators/HLR/Edit"
                    component={HLREdit}
                />
                <InnerLayoutRoute
                    path="/ProvidersAdd/Add"
                    component={ProviderDetailAdd}
                />
                {/* <InnerLayoutRoute
                    path="/ProviderDetails"
                    exact
                    component={ProviderAdd}
                /> */}
                <InnerLayoutRoute
                    path="/ProvidersAdd"
                    exact
                    component={ProviderAdd}
                />
                <InnerLayoutRoute
                    path="/DMTPipeMaster"
                    exact
                    component={DMTPipeMaster}
                />
                <InnerLayoutRoute
                    path="/Providers/Edit"
                    component={ProviderEdit}
                />
                <InnerLayoutRoute
                    path="/ProviderDetails/Edit"
                    component={ProviderDetailEdit}
                />
                <InnerLayoutRoute
                    path="/ProviderConfiguration/Index"
                    component={ProviderConfigSetup}
                />
                <InnerLayoutRoute
                    path="/ProviderConfiguration/Edit"
                    component={ProviderOperatorEdit}
                />
                <InnerLayoutRoute
                    path="/ProviderConfiguration"
                    exact
                    component={ProviderAdd}
                />
                <InnerLayoutRoute
                    path="/Slabs/ROfferCommission"
                    component={ROfferCommissionAdd}
                />
                <InnerLayoutRoute
                    path="/UserWiseLatLong"
                    exact
                    component={UserWiseLatLong}
                />
                <InnerLayoutRoute path="/Slabs" exact component={SlabAdd} />
                <InnerLayoutRoute path="/Slabs/Assign" component={SlabAssign} />
                <InnerLayoutRoute
                    path="/Slabs/SlabAssignEdit"
                    component={SlabAssignEdit}
                />
                <InnerLayoutRoute
                    path="/Slabs/Commission"
                    component={SlabCommission}
                />
                <InnerLayoutRoute
                    path="/Slabs/DMTCommission"
                    component={DMTSlabCommission}
                />
                <InnerLayoutRoute
                    path="/Slabs/OfflineSlabCommission"
                    component={OfflineSlabCommission}
                />
                <InnerLayoutRoute
                    path="/ChannelSlabs/Commission"
                    component={ChannelSlabCommission}
                />
                <InnerLayoutRoute
                    path="/ChannelSlabs/DMTCommission"
                    component={DMTChannelSlabCommission}
                />
                <InnerLayoutRoute path="/ChannelSlabs" exact component={Add} />
                <InnerLayoutRoute
                    path="/ChannelSlabAssign"
                    exact
                    component={ChannelSlabAssign}
                />
                <InnerLayoutRoute
                    path="/ChannelSlabs/AssignEdit"
                    component={AssignEdit}
                />
                <InnerLayoutRoute
                    path="/ProvidersSequence"
                    component={SequenceAdd}
                />
                <InnerLayoutRoute
                    exact
                    path="/Sequence"
                    component={SequenceAdd}
                />
                <InnerLayoutRoute
                    path="/Sequence/Edit"
                    component={SequenceEdit}
                />
                <InnerLayoutRoute
                    path="/Sequence/UserWise"
                    component={SequenceUserWiseAdd}
                />
                <InnerLayoutRoute
                    path="/UserWiseDMTSequenceAdd"
                    component={UserWiseDMTSequenceAdd}
                />
                <InnerLayoutRoute
                    exact
                    path="/UserwiseSequenceIndex"
                    component={UserwiseSequenceIndex}
                />
                <InnerLayoutRoute
                    exact
                    path="/I_SenderSearch"
                    component={IDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/I_SenderAdd"
                    component={IDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/I_SenderVerify"
                    component={IDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/I_BeneficiaryDelete"
                    component={IDMTBeneficiaryDelete}
                />
                <InnerLayoutRoute
                    path="/I_BeneficiaryAdd"
                    component={IDMTBeneficiaryAdd}
                />
                {/* <InnerLayoutRoute
                    path="/PC_SenderSearch"
                    component={PaytmCCFDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/PC_SenderAdd"
                    component={PaytmCCFDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/PC_BeneficiaryDelete"
                    component={PaytmCCFDMTBeneficiaryDelete}
                />
                <InnerLayoutRoute
                    path="/PC_BeneficiaryAdd"
                    component={PaytmCCFDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/PC_BeneficiaryVerify"
                    component={PaytmCCFDMTBeneficiaryVerify}
                />*/}
                <InnerLayoutRoute
                    path="/WPC_SenderAdd"
                    component={WhiteLabelPaytmCCFDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/WPC_BeneficiaryDelete"
                    component={WhiteLabelPaytmCCFDMTBeneficiaryDelete}
                />
                <InnerLayoutRoute
                    path="/WPC_BeneficiaryAdd"
                    component={WhiteLabelPaytmCCFDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/WPC_BeneficiaryVerify"
                    component={WhiteLabelPaytmCCFDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/PSTransaction"
                    component={PaysprintTransaction}
                />
                <InnerLayoutRoute
                    path="/PSRedirectURL"
                    component={PSRedirectURL}
                />
                <InnerLayoutRoute
                    exact
                    path="/PS_SenderAdd"
                    component={PSSenderAdd}
                />
                <InnerLayoutRoute
                    exact
                    path="/PS_SenderAadharVerifyBank2"
                    component={PSSenderAadharVerifyBank2}
                />
                <InnerLayoutRoute
                    exact
                    path="/PS_PSSenderEKYCBank2"
                    component={PSSenderEKYCBank2}
                />
                <InnerLayoutRoute
                    exact
                    path="/PS_SenderAuthentication"
                    component={PSSenderAuthentication}
                />
                <InnerLayoutRoute
                    exact
                    path="/PS_TransactionConfirmation"
                    component={PSTransactionConfirmation}
                />
                <InnerLayoutRoute
                    exact
                    path="/PS_SplitAmount"
                    component={PSSplitAmount}
                />
                <InnerLayoutRoute
                    exact
                    path="/PS_BeneficiaryAdd"
                    component={PSBeneficiaryAdd}
                />

                <InnerLayoutRoute
                    exact
                    path="/CS_SenderAuthentication"
                    component={CSSenderAuthentication}
                />
                <InnerLayoutRoute
                    exact
                    path="/CS_TransactionConfirmation"
                    component={CSTransactionConfirmation}
                />
                <InnerLayoutRoute
                    exact
                    path="/CS_SplitAmount"
                    component={CSSplitAmount}
                />
                <InnerLayoutRoute
                    exact
                    path="/CS_BeneficiaryAdd"
                    component={CSBeneficiaryAdd}
                />


                <InnerLayoutRoute
                    path="/MG_SenderAdd"
                    component={MahagramDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/MG_BeneficiaryAdd"
                    component={MahagramDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/MG_BeneficiaryVerify"
                    component={MahagramDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/MG_SenderVerify"
                    component={MahagramDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/MG_BeneGetOTP"
                    component={MahagramDMTBeneGetOTP}
                />
                <InnerLayoutRoute
                    exact
                    path="/MMoney_SenderSearch"
                    component={MMoneyDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/MMoney_SenderAdd"
                    component={MMoneyDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/MMoney_BeneficiaryAdd"
                    component={MMoneyDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/CDMT_Transfer"
                    component={CDMTTransfer}
                />
                <InnerLayoutRoute
                    path="/CDMT_SenderAdd"
                    component={CDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/CDMT_SenderVerify"
                    component={CDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/CDMT_BeneficiaryDelete"
                    component={CDMTBeneficiaryDelete}
                />
                <InnerLayoutRoute
                    path="/CDMT_BeneficiaryAdd"
                    component={CDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    exact
                    path="/MDMT/Sender"
                    component={MDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/MDMT/Sender/Search"
                    component={MDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/MDMT/Transfer"
                    component={MDMTTransfer}
                />
                <InnerLayoutRoute
                    path="/MDMT/Sender/Add"
                    component={MDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/MDMT/Sender/Verify"
                    component={MDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/MDMT/Beneficiary/Add/"
                    component={MDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/MDMT/Beneficiary/Verify/"
                    component={MDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/AD_SenderSearch"
                    component={AlleDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/AD_SenderAdd"
                    component={AlleDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/AD_SenderVerify"
                    component={AlleDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/AD_BeneficiaryAdd"
                    component={AlleDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/ZP_SenderAdd"
                    component={ZPlusDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/ZP_SenderVerify"
                    component={ZPlusDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/ZP_BeneficiaryAdd"
                    component={ZPlusDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/NBDMT_SenderOnboard"
                    component={NSDLSenderAdd}
                />
                <InnerLayoutRoute
                    path="/NBDMT_GenerateOTP"
                    component={GenerateSenderKYCOTP}
                />
                <InnerLayoutRoute
                    path="/NBDMT_VerifySenderOTP"
                    component={VerifySenderKYCOTP}
                />
                <InnerLayoutRoute
                    path="/NBDMT_SenderAuthentication"
                    component={SenderKYCAuthentication}
                />
                <InnerLayoutRoute
                    path="/NBDMT_BeneficiaryAdd"
                    component={BeneficiaryADD}
                />
                <InnerLayoutRoute
                    path="/NBDMT_SplitAmount"
                    component={NBSplitAmount}
                />
                <InnerLayoutRoute
                    path="/OADMT_SenderOnboard"
                    component={OnlyApiSenderAdd}
                />
                <InnerLayoutRoute
                    path="/OADMT_GenerateOTP"
                    component={OnlyApiGenerateSenderKYCOTP}
                />
                <InnerLayoutRoute
                    path="/OADMT_VerifySenderOTP"
                    component={OnlyApiVerifySenderKYCOTP}
                />
                <InnerLayoutRoute
                    path="/OADMT_SenderAuthentication"
                    component={OnlyApiSenderKYCAuthentication}
                />
                <InnerLayoutRoute
                    path="/OADMT_BeneficiaryAdd"
                    component={OnlyApiBeneficiaryADD}
                />
                <InnerLayoutRoute
                    path="/OADMT_SplitAmount"
                    component={OnlyApiSplitAmount}
                />
                <InnerLayoutRoute
                    path="/EZPV1SenderAdd"
                    component={EzyPayV1DMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/EZPV1_GenerateSenderOTP"
                    component={EzyPayV1GenerateSenderOTP}
                />
                <InnerLayoutRoute
                    path="/EZPV1_VerifySenderOTP"
                    component={EzyPayV1VerifySenderOTP}
                />
                <InnerLayoutRoute
                    path="/EZPV1_SenderAuthentication"
                    component={EzyPayV1SenderAuthentication}
                />
                <InnerLayoutRoute
                    path="/EZPV1SenderVerify"
                    component={EzyPayV1DMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/EZPV1BeneficiaryAdd"
                    component={EzyPayV1DMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/EZPV1_TransactionConfirmation"
                    component={TransactionConfirmation}
                />
                <InnerLayoutRoute
                    path="/PPIVerifySenderOTP"
                    component={PayPointVerifySenderOTP}
                />
                <InnerLayoutRoute
                    path="/PPIVerifyAadharOTP"
                    component={PayPointVerifyAadharOTP}
                />
                <InnerLayoutRoute
                    path="/PPIGenerateAadharOTP"
                    component={PayPointGenerateAadharOTP}
                />
                <InnerLayoutRoute
                    path="/PPIBeneficiaryAdd"
                    component={PayPointBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/PPIPanCardKYC"
                    component={PayPointPanCardKYC}
                />
                <InnerLayoutRoute
                    path="/PPIBenificiaryList"
                    component={PayPointBenificiaryList}
                />
                <InnerLayoutRoute
                    path="/PPIBeneDeleteOTP"
                    component={PayPointBeneDeleteOTP}
                />
                <InnerLayoutRoute
                    path="/PS_PPIRedirectURL"
                    component={PaysprintPPIRedirectURL}
                />
                <InnerLayoutRoute
                    path="/EZPSenderAdd"
                    component={EzyPayDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/EZPV1_SplitAmount"
                    component={EZPV1SplitAmount}
                />
                <InnerLayoutRoute
                    path="/EZPSenderVerify"
                    component={EzyPayDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/EZPBeneficiaryAdd"
                    component={EzyPayDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/EZPTMSenderAdd"
                    component={EzyPayPaytmDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/EZPTMSenderVerify"
                    component={EzyPayPaytmDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/EZPTMBeneficiaryAdd"
                    component={EzyPayPaytmDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    exact
                    path="/NT5LDMT_AgentRegistration"
                    component={() => (
                        <NTDMT5LAgentRegistration ActiveDMTName=" " />
                    )}
                />
                <InnerLayoutRoute
                    path="/NT5LDMT_SenderAdd"
                    component={NTDMT5LSenderAdd}
                />
                <InnerLayoutRoute
                    path="/NT5LDMT_BeneVerify"
                    component={NTDMT5LBeneVerify}
                />
                <InnerLayoutRoute
                    path="/NT5LDMT_SenderVerify"
                    component={NTDMT5LSenderVerify}
                />
                <InnerLayoutRoute
                    path="/NT5LDMT_BeneficiaryAdd"
                    component={NT5LDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/NT5LDMT_BeneDeleteVerify"
                    component={NTDMT5LBeneDeleteVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/NTDMT_AgentRegistration"
                    component={() => (
                        <NTDMTAgentRegistration ActiveDMTName=" " />
                    )}
                />
                <InnerLayoutRoute
                    path="/NTDMT_SenderAdd"
                    component={NTDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/NTDMT_AirtelBankSenderAdd"
                    component={NTDMTAirtelBankSenderAdd}
                />
                <InnerLayoutRoute
                    path="/NTDMT_NSDLBankSenderAdd"
                    component={NTDMTNSDLBankSenderAdd}
                />
                <InnerLayoutRoute
                    path="/NTDMT_BeneVerify"
                    component={NTDMTBeneVerify}
                />
                <InnerLayoutRoute
                    path="/NTDMT_SenderVerify"
                    component={NTDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/NTDMT_AirtelBankSenderVerify"
                    component={NTDMTAirtelBankSenderVerify}
                />
                <InnerLayoutRoute
                    path="/NTDMT_NSDLBankSenderOTPVerify"
                    component={NTDMTNSDLBankSenderOTPVerify}
                />
                <InnerLayoutRoute
                    path="/NTDMT_BeneficiaryAdd"
                    component={NTDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/NTDMT_BeneDeleteVerify"
                    component={NTDMTBeneDeleteVerify}
                />
                <InnerLayoutRoute
                    path="/NTDMT_GenerateSenderOTP"
                    component={NTDMTGenerateSenderOTP}
                />
                <InnerLayoutRoute
                    path="/NTDMT_SenderEKYC"
                    component={NTDMTSenderEKYC}
                />
                <InnerLayoutRoute
                    path="/NTDMT_AirtelSenderEKYC"
                    component={NTDMTAirtelSenderEKYC}
                />
                <InnerLayoutRoute
                    path="/NTDMT_NSDLBank3SenderAdharVerifyEKYC"
                    component={NTDMTNSDLBank3SenderAdharVerifyEKYC}
                />
                <InnerLayoutRoute
                    path="/NTDMT_TransactionConfirmation"
                    component={NTDMTTransactionConfirmation}
                />
                <InnerLayoutRoute
                    path="/NTDMT_SplitAmount"
                    component={NTDMTSplitAmount}
                />
                <InnerLayoutRoute
                    exact
                    path="/KYCPPI_SenderRegistration"
                    component={() => (
                        <KYCPPISenderRegistration ActiveDMTName=" " />
                    )}
                />
                <InnerLayoutRoute
                    path="/KYCPPI_SenderVerify"
                    component={KYCPPI_SenderVerify}
                />
                <InnerLayoutRoute
                    path="/KYCPPI_SenderSearch"
                    component={KYCPPI_SenderSearch}
                />
                <InnerLayoutRoute
                    path="/KYCPPI_SendereKYC"
                    exact
                    component={KYCPPI_eKYC}
                />
                <InnerLayoutRoute
                    path="/KYCPPI_BeneAdd"
                    exact
                    component={KYCPPI_BeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/KYCPPI_TransactionConfirmation"
                    component={KYCPPITransactionConfirmation}
                />
                <InnerLayoutRoute
                    path="/KYCPPI_SplitAmount"
                    component={ICICISplitAmount}
                />
                <InnerLayoutRoute
                    path="/Eko_SenderAdd"
                    component={EkoDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/Eko_SenderVerify"
                    component={EkoDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/Eko_BeneficiaryAdd"
                    component={EkoDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    exact
                    path="/EDMT/Sender"
                    component={EDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/EDMT/Sender/Search"
                    component={EDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/EDMT/Sender/Add"
                    component={EDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/EDMT/Sender/Verify"
                    component={EDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/EDMT/Beneficiary/Add/"
                    component={EDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/EDMT/Beneficiary/Verify/"
                    component={EDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/EDMT/Beneficiary/Delete/"
                    component={EDMTBeneficiaryDelete}
                />
                <InnerLayoutRoute
                    path="/OB_SenderAdd"
                    component={OpenBankSenderAdd}
                />
                <InnerLayoutRoute
                    path="/OB_SenderVerify"
                    component={OpenBankSenderVerify}
                />
                <InnerLayoutRoute
                    path="/OB_BeneficiaryAdd"
                    component={OpenBankBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/OB_BeneficiaryVerify"
                    component={OpenBankBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/PDMTSender"
                    component={PDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/PDMTSender/Search"
                    component={PDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/PDMT/Transfer"
                    component={PDMTTransfer}
                />
                <InnerLayoutRoute
                    path="/PDMTSender/Add"
                    component={PDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/PDMTSender/Verify"
                    component={PDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/PDMTBeneficiaryAdd/"
                    component={PDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/PDMTBeneficiary/Verify/"
                    component={PDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/PU_SenderAdd"
                    component={PayUDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/PU_SenderVerify"
                    component={PayUDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/PU_BeneficiaryAdd"
                    component={PayUDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/PU_BeneficiaryVerify"
                    component={PayUDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/IC_SenderSearch"
                    component={ICompositeDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/IC_SenderAdd"
                    component={ICompositeDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/IC_SenderVerify"
                    component={ICompositeDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/IC_BeneAdd"
                    component={ICompositeDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/IC_BeneVerify"
                    component={ICompositeDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/RP_SenderAdd"
                    component={RazorpayDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/RP_SenderVerify"
                    component={RazorpayDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/RP_BeneAdd"
                    component={RazorpayDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/RP_BeneVerify"
                    component={RazorpayDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/JJ_SenderAdd"
                    component={JaiJuiDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/JJ_SenderVerify"
                    component={JaiJuiSenderVerify}
                />
                <InnerLayoutRoute
                    path="/JJ_BeneAdd"
                    component={JaiJuiBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/JJ_BeneVerify"
                    component={JaiJuiDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/SenderAdd"
                    component={CommonDMTAsPayoutSenderAdd}
                />
                <InnerLayoutRoute
                    path="/UPISenderAdd"
                    component={UPISenderAdd}
                />
                <InnerLayoutRoute
                    path="/UPISenderSearch"
                    component={UPISenderSearch}
                />
                <InnerLayoutRoute
                    path="/UPISenderVerify"
                    component={UPISenderVerify}
                />
                <InnerLayoutRoute
                    path="/UPIBeneficiaryAdd"
                    component={UPIBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/UPIBeneficiaryVerify"
                    component={UPIBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/SenderVerify"
                    component={CommonDMTAsPayoutSenderVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/C_SenderSearch"
                    component={DMTAsPayoutSenderSearch}
                />
                <InnerLayoutRoute
                    path="/BeneAdd"
                    component={CommonDMTAsPayoutBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/AddContact"
                    component={EzyPayoutAddContact}
                />
                <InnerLayoutRoute
                    path="/BeneVerify"
                    component={CommonDMTAsPayoutBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/PP_SenderSearch"
                    component={PrimePayDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/PP_SenderAdd"
                    component={PrimePayDMTenderAdd}
                />
                <InnerLayoutRoute
                    path="/PP_SenderVerify"
                    component={PrimePayDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/PP_BeneAdd"
                    component={PrimePayDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/PP_BeneVerify"
                    component={PrimePayDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/H_SenderAdd"
                    component={HyptoDMTenderAdd}
                />
                <InnerLayoutRoute
                    path="/H_SenderVerify"
                    component={HyptoDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/H_BeneAdd"
                    component={HyptoDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/H_BeneVerify"
                    component={HyptoDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/ZPP_SenderAdd"
                    component={ZplusPayoutDMTenderAdd}
                />
                <InnerLayoutRoute
                    path="/ZPP_SenderVerify"
                    component={ZplusPayoutDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/ZPP_BeneAdd"
                    component={ZplusPayoutDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/ZPP_BeneVerify"
                    component={ZplusPayoutDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/CF_SenderAdd"
                    component={CFDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/CF_SenderVerify"
                    component={CFSenderVerify}
                />
                <InnerLayoutRoute
                    path="/CF_BeneAdd"
                    component={CFBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/CF_BeneVerify"
                    component={CFDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/AB_SenderAdd"
                    component={AmbikaDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/AB_SenderVerify"
                    component={AmbikaDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/AB_BeneAdd"
                    component={AmbikaDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/AB_BeneVerify"
                    component={AmbikaDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/ROP_SenderAdd"
                    component={RoundPayDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/ROP_SenderVerify"
                    component={RoundPayDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/ROP_BeneAdd"
                    component={RoundPayDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/ROP_BeneVerify"
                    component={RoundPayDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/VW_SenderAdd"
                    component={VastWebDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/IG_SenderAdd"
                    component={IMPSGuruDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/VW_SenderVerify"
                    component={VastWebDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/VW_BeneAdd"
                    component={VastWebDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/IG_BeneAdd"
                    component={IMPSGuruBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/LF_SenderAdd"
                    component={LevinDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/LF_SenderVerify"
                    component={LevinDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/LF_BeneAdd"
                    component={LevinDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/CIT_SenderAdd"
                    component={ClareInfoTechDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/CIT_BeneAdd"
                    component={ClareInfoTechDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/CIT_SenderVerify"
                    component={ClareInfoTechDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/CIT_BeneVerify"
                    component={ClareInfoTechDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    path="/CIT_BeneDeleteVerify"
                    component={ClareInfoTechDMTBeneDeleteVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/ICashDMT/Sender"
                    component={ICashDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/ICashDMT/Sender/Search"
                    component={ICashDMTSenderSearch}
                />
                <InnerLayoutRoute
                    path="/ICashDMT/Transfer"
                    component={ICashDMTTransfer}
                />
                <InnerLayoutRoute
                    path="/ICashDMT/Sender/Add"
                    component={ICashDMTSenderAdd}
                />
                <InnerLayoutRoute
                    path="/ICashDMT/Sender/Verify"
                    component={ICashDMTSenderVerify}
                />
                <InnerLayoutRoute
                    path="/ICashDMT/Beneficiary/Add/"
                    component={ICashDMTBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/ICashDMT/Beneficiary/Verify/"
                    component={ICashDMTBeneficiaryVerify}
                />
                <InnerLayoutRoute
                    exact
                    path="/MNLDMTSender"
                    component={MyNetLinkSenderSearch}
                />
                <InnerLayoutRoute
                    path="/MNLDMT_Transfer"
                    component={MyNetLinkTransfer}
                />
                <InnerLayoutRoute
                    path="/MNLDMTSender_Add"
                    component={MyNetLinkSenderAdd}
                />
                <InnerLayoutRoute
                    path="/MNLDMTBeneficiaryAdd"
                    component={MyNetLinkBeneficiaryAdd}
                />
                <InnerLayoutRoute
                    path="/IPGTransaction"
                    component={IPGTransaction}
                />
                <InnerLayoutRoute
                    path="/OBPGTransaction"
                    component={OpenBankPGTransaction}
                />
                <InnerLayoutRoute
                    path="/UPIGatewayTransaction"
                    component={UPIGatewayTransaction}
                />
                <InnerLayoutRoute
                    path="/PTransaction"
                    component={PTransaction}
                />
                <InnerLayoutRoute
                    path="/CTransaction"
                    component={CTransaction}
                />

                <InnerLayoutRoute
                    path="/RazorpayQRTransaction"
                    component={RazorpayQRTransaction}
                />
                <InnerLayoutRoute
                    path="/IMoneyPayPG"
                    component={IMoneyPayTransaction}
                />
                <InnerLayoutRoute
                    path="/PayGoalPG"
                    component={PayGoalTransaction}
                />
                {/* <InnerLayoutRoute
                    path="/UGTransaction"
                    component={UGTransaction}
                /> */}
                <InnerLayoutRoute
                    exact
                    path="/PaymentGatewayTransaction"
                    component={GatewayTransaction}
                />
                <InnerLayoutRoute
                    exact
                    path="/CreditCardToBank"
                    component={CreditCardToBank}
                />
                <InnerLayoutRoute
                    exact
                    path="/CheckCIBILScore"
                    component={CheckCIBILScore}
                />
                <InnerLayoutRoute
                    exact
                    path="/PaymentGatewayReport"
                    component={PaymentGatewayReport}
                />
                <InnerLayoutRoute
                    exact
                    path="/UserReferralReport"
                    component={UserReferralReport}
                />
                <InnerLayoutRoute
                    exact
                    path="/OperatorWiseUserWiseReport"
                    component={OperatorWiseUserWiseReport}
                />
                <InnerLayoutRoute
                    exact
                    path="/ReferredUserReport"
                    component={ReferredUserReport}
                />
                <InnerLayoutRoute
                    exact
                    path="/ReferAndEarn"
                    component={ReferAndEarn}
                />
                <InnerLayoutRoute
                    exact
                    path="/PGSuccess"
                    component={PGSuccess}
                />
                <InnerLayoutRoute exact path="/PGFail" component={PGFail} />
                <InnerLayoutRoute
                    exact
                    path="/IPRegistrationOTP"
                    component={IPRegistrationOTP}
                />
                <InnerLayoutRoute
                    exact
                    path="/QRCodeGenerate"
                    component={QRCodeGenerate}
                />
                <InnerLayoutRoute
                    path="/IPRegistration"
                    component={IPRegistration}
                />
                <InnerLayoutRoute
                    path="/EkoUserOnbording"
                    component={EkoUserOnbording}
                />
                <InnerLayoutRoute
                    exact
                    path="/IPChangeMobile"
                    component={IPChangeMobile}
                />
                <InnerLayoutRoute
                    path="/IPChangeMoblieVerify"
                    component={IPChangeMoblieVerify}
                />
                <InnerLayoutRoute path="/DMTReport" component={DMTReport} />
                <InnerLayoutRoute path="/PPIReport" component={PPIReport} />
                <InnerLayoutRoute
                    path="/ResponseAdd"
                    component={ProviderResponseAdd}
                />
                <InnerLayoutRoute
                    path="/Daybook"
                    exact
                    component={DaybookReport}
                />
                <InnerLayoutRoute
                    path="/Daybook/Report"
                    component={DaybookReport}
                />
                <InnerLayoutRoute
                    path="/ProviderDayBook"
                    exact
                    component={ProviderDayBookReport}
                />
                <InnerLayoutRoute path="/AEPSReport" component={AEPSReport} />
                <InnerLayoutRoute path="/Income" component={IncomeReport} />
                <InnerLayoutRoute
                    path="/MicroATMReport"
                    component={MicroATMReport}
                />
                <InnerLayoutRoute path="/POSReport" component={POSReport} />
                <InnerLayoutRoute path="/CMSReport" component={CMSReport} />
                <InnerLayoutRoute path="/IPAdd" exact component={IPAdd} />
                <InnerLayoutRoute
                    path="/CallbackAdd"
                    exact
                    component={CallbackAdd}
                />
                <InnerLayoutRoute path="/Log" exact component={SelectByIDLog} />
                <InnerLayoutRoute
                    path="/Log/Report"
                    component={SelectByIDLog}
                />
                <InnerLayoutRoute
                    path="/PaymentGatewayLog"
                    component={PaymentGatewayLog}
                />
                <InnerLayoutRoute
                    path="/ApiUserLog"
                    component={APIUserInitialLog}
                />
                <InnerLayoutRoute
                    path="/CallbackMaster/Edit"
                    component={CallbackEdit}
                />
                <InnerLayoutRoute
                    path="/CommissionStructure"
                    component={SlabDetailByUser}
                />
                <InnerLayoutRoute
                    path="/KeySetting"
                    component={SelectSettingMaster}
                />
                <InnerLayoutRoute path="/KeyEdit" component={SettingEdit} />
                <InnerLayoutRoute path="/SMSAdd" component={SMSAdd} />
                <InnerLayoutRoute
                    path="/MessageSetting"
                    component={MessageSetting}
                />
                <InnerLayoutRoute
                    path="/WebHookSetting"
                    component={WebHookSetting}
                />
                <InnerLayoutRoute
                    path="/CashCollection"
                    exact
                    component={CashCollect}
                />
                <InnerLayoutRoute
                    path="/CashCollectionAdd"
                    component={CashCollect}
                />
                <InnerLayoutRoute
                    path="/CashCollectionReverse"
                    component={CashCollectionReverse}
                />
                <InnerLayoutRoute
                    path="/CashCollectionReport"
                    component={CashCollectionReport}
                />
                <InnerLayoutRoute path="/Complaints" component={Complaints} />
                <InnerLayoutRoute path="/AddBank" component={BankAdd} />
                <InnerLayoutRoute
                    exact
                    path="/VirtualBalance"
                    component={VirtualBalanceAdd}
                />
                <InnerLayoutRoute
                    path="/IDPurchaseReport"
                    component={IDPurchaseReport}
                />
                <InnerLayoutRoute
                    path="/VirtualBalance/Add"
                    component={VirtualBalanceAdd}
                />
                <InnerLayoutRoute path="/SmsReport" component={SmsReport} />
                <InnerLayoutRoute
                    path="/OperatorUserwise"
                    component={OperatorUserwise}
                />
                <InnerLayoutRoute
                    path="/OperatorWiseViewProvider"
                    component={OperatorWiseViewProvider}
                />
                <InnerLayoutRoute
                    path="/UserwiseServiceCharge"
                    component={UserwiseServiceCharge}
                />
                <InnerLayoutRoute
                    path="/ServiceSubscriptionCharge"
                    component={ServiceSubscriptionCharge}
                />
                <InnerLayoutRoute
                    path="/UserWisePlanLimitSetting"
                    component={UserWisePlanLimitSetting}
                />
                <InnerLayoutRoute
                    path="/LeadGeneration"
                    exact
                    component={LeadGeneration}
                />
                <InnerLayoutRoute
                    path="/AddBeneficiary"
                    exact
                    component={AddBeneficiary}
                />
                <InnerLayoutRoute
                    path="/OnlyAPILeadGeneration"
                    exact
                    component={OnlyAPILeadGeneration}
                />
                <InnerLayoutRoute
                    path="/PendingSubcriptionCharge"
                    component={PendingSubcriptionCharge}
                />
                <InnerLayoutRoute
                    path="/SubscriptionChargeReport"
                    component={SubscriptionChargeReport}
                />
                <InnerLayoutRoute
                    path="/GrowthLossReport"
                    component={GrowthLossReport}
                />
                <InnerLayoutRoute
                    path="/AccountStatementReport"
                    component={AccountStatementReport}
                />
                <InnerLayoutRoute
                    path="/SubscriptionPaymentReport"
                    component={SubscriptionPaymentReport}
                />
                <InnerLayoutRoute
                    path="/SubscriptionPendingPayment"
                    component={SubscriptionPendingPayment}
                />
                <InnerLayoutRoute
                    path="/SupportAccess"
                    component={SupportAccess}
                />
                <InnerLayoutRoute
                    path="/UserActionHistory"
                    component={UserActionHistory}
                />
                <InnerLayoutRoute
                    path="/FundReverseRequestReport"
                    component={ReverseRequestReport}
                />
                <InnerLayoutRoute
                    path="/Fund/ReverseRequest"
                    component={ReverseRequest}
                />
                <InnerLayoutRoute
                    path="/Fund/ReverseTransferReport"
                    component={ReverseTransferReport}
                />
                <InnerLayoutRoute
                    path="/ServiceChargeDeductionReport"
                    component={ServiceChargeDeductionReport}
                />
                <InnerLayoutRoute
                    path="/CircleAPIAdd"
                    component={CircleAPIAdd}
                />
                <InnerLayoutRoute
                    path="/SaleReport"
                    component={ServicewiseSale}
                />
                <InnerLayoutRoute
                    path="/UserwiseSale"
                    component={UserwiseSale}
                />
                <InnerLayoutRoute
                    path="/ProviderSale"
                    component={ProviderSale}
                />
                <InnerLayoutRoute
                    path="/AmountWiseInsights"
                    component={AmountWiseInsights}
                />
                <InnerLayoutRoute
                    path="/WalletTransfer"
                    component={WalletTransfer}
                />
                <InnerLayoutRoute
                    path="/Notification"
                    component={NotificationAdd}
                />
                <InnerLayoutRoute
                    path="/EBTransaction"
                    component={EasebuzzTransaction}
                />
                <InnerLayoutRoute path="/Document" component={Document} />
                <InnerLayoutRoute
                    path="/PlanApiDocument"
                    component={PlanApiDocument}
                />{' '}
                {/*  */}
                <InnerLayoutRoute path="/DMTDocument" component={DMTDocument} />
                <InnerLayoutRoute
                    path="/AEPSDocument"
                    component={AEPSDocument}
                />
                <InnerLayoutRoute
                    path="/WebViewDocument"
                    component={WebViewDocument}
                />
                <InnerLayoutRoute
                    path="/ADMTDocument"
                    component={ADMTDocument}
                />
                <InnerLayoutRoute
                    path="/EkoDMTDocument"
                    component={EkoDMTDocument}
                />
                <InnerLayoutRoute
                    path="/MDMTDocument"
                    component={MDMTDocument}
                />
                <InnerLayoutRoute
                    path="/PDMTDocument"
                    component={PDMTDocument}
                />
                <InnerLayoutRoute
                    path="/ICICI_CompositeDMTDocument"
                    component={ICICI_CompositeDMTDocument}
                />
                <InnerLayoutRoute
                    path="/ICICI_CompositeDMTDoc"
                    component={ICICI_CompositeDMTDoc}
                />
                <InnerLayoutRoute
                    path="/DMTAPIDocument"
                    component={CommonDMTDocument}
                />
                <InnerLayoutRoute
                    path="/ICashDMTDocument"
                    component={ICashDMTDocument}
                />
                <InnerLayoutRoute
                    path="/IDMTDocument"
                    component={IDMTDocument}
                />
                <InnerLayoutRoute
                    path="/MahagramDMTDocument"
                    component={MahagramDMTDocument}
                />
                <InnerLayoutRoute
                    path="/CDMTDocument"
                    component={CDMTDocument}
                />
                <InnerLayoutRoute
                    path="/EDMTDocument"
                    component={EDMTDocument}
                />
                <InnerLayoutRoute
                    path="/PCCFDMTDocument"
                    component={PCCFDMTDocument}
                />
                <InnerLayoutRoute
                    path="/CFDMTDocument"
                    component={CFDMTDocument}
                />
                <InnerLayoutRoute
                    path="/CircleSwitching"
                    component={CircleSwitching}
                />
                <InnerLayoutRoute path="/CircleIndex" component={CircleIndex} />
                <InnerLayoutRoute path="/UserToken" component={UserToken} />
                <InnerLayoutRoute path="/ProviderLog" component={ProviderLog} />
                <InnerLayoutRoute path="/WebHookLog" component={WebHookLog} />
                <InnerLayoutRoute path="/PendingIP" component={PendingIP} />
                <InnerLayoutRoute
                    path="/LapuReport"
                    exact
                    component={LapuReport}
                />
                <InnerLayoutRoute path="/News/Index" component={News} />
                <InnerLayoutRoute path="/XMPP/Status" component={XMPPStatus} />
                <InnerLayoutRoute
                    path="/EmailSetting/Index"
                    component={EmailSetting}
                />
                <InnerLayoutRoute
                    path="/EmailSetting/Edit"
                    component={EmailEdit}
                />
                <InnerLayoutRoute
                    path="/EmailSetting/Add"
                    component={EmailAdd}
                />
                <InnerLayoutRoute
                    path="/DenominationDetails/Denomination"
                    component={DenominationAdd}
                />
                <InnerLayoutRoute
                    path="/LiveTransaction"
                    exact
                    component={LiveTransaction}
                />
                <InnerLayoutRoute
                    path="/BBPSConfiguration"
                    exact
                    component={BBPSConfiguration}
                />
                <InnerLayoutRoute
                    path="/BBPSConfiguration/Index"
                    exact
                    component={BBPSConfiguration}
                />
                <InnerLayoutRoute
                    path="/BBPSConfiguration/Add"
                    component={BBPSConfigurationAdd}
                />
                <InnerLayoutRoute
                    path="/BBPSConfiguration/Edit"
                    component={BBPSConfigurationEdit}
                />
                <InnerLayoutRoute
                    path="/DMTSettings"
                    exact
                    component={DMTSettings}
                />
                <InnerLayoutRoute
                    path="/DMTSettings/Index"
                    exact
                    component={DMTSettings}
                />
                <InnerLayoutRoute
                    path="/PPISetting/Index"
                    exact
                    component={PPISetting}
                />
                <InnerLayoutRoute
                    path="/DematSetting"
                    exact
                    component={DematSetting}
                />
                <InnerLayoutRoute
                    path="/VerificationSettings"
                    exact
                    component={VerificationSettings}
                />
                <InnerLayoutRoute
                    path="/UPITransferSetting"
                    exact
                    component={UPITransferSettings}
                />
                <InnerLayoutRoute
                    path="/AccountOpenSetting"
                    exact
                    component={AccountOpenSettings}
                />
                <InnerLayoutRoute
                    path="/CIBILScoreSetting/Index"
                    exact
                    component={CIBILScoreSetting}
                />
                <InnerLayoutRoute
                    path="/ThirdPartyServiceProvider"
                    exact
                    component={ThirdPartyServiceProvider}
                />
                <InnerLayoutRoute
                    path="/ThirdPartyServiceProvider/Index"
                    exact
                    component={ThirdPartyServiceProvider}
                />
                <InnerLayoutRoute
                    path="/ProviderWiseFailReport"
                    exact
                    component={ProviderWiseFailReport}
                />
                <InnerLayoutRoute
                    path="/Slider"
                    exact
                    component={SliderIndex}
                />
                <InnerLayoutRoute
                    path="/PushNotifications"
                    exact
                    component={PushNotificationsIndex}
                />
                <InnerLayoutRoute path="/UserLedger" component={LedgerReport} />
                <InnerLayoutRoute
                    path="/UserWiseServiceSellReport"
                    component={UserWiseServiceSellReport}
                />
                <InnerLayoutRoute path="/AdminLedger" component={AdminLedger} />
                <InnerLayoutRoute
                    path="/ProviderFailure"
                    component={APIFailure}
                />
                <InnerLayoutRoute
                    path="/CallMeRequest"
                    component={CallMeRequest}
                />
                <InnerLayoutRoute path="/AddPurchase" component={AddPurchase} />
                <InnerLayoutRoute
                    path="/CallRequestReport"
                    component={CallRequestReport}
                />
                <InnerLayoutRoute
                    path="/PayoutReport"
                    component={PayoutReport}
                />
                <InnerLayoutRoute
                    path="/BulkPaySetting"
                    component={BulkPaySetting}
                />
                <InnerLayoutRoute
                    path="/BusSettingMaster"
                    component={BusSettingMaster}
                />
                <InnerLayoutRoute
                    path="/RichTextMedia"
                    component={RichTextMedia}
                />
                <InnerLayoutRoute path="/OTTSetting" component={OTTSetting} />
                <InnerLayoutRoute
                    path="/PayoutBeneficiaryReport"
                    component={BeneficiaryReport}
                />
                <InnerLayoutRoute
                    path="/NSDLBeneficiaryReport"
                    component={NSDLBeneficiaryReport}
                />
                <InnerLayoutRoute
                    path="/OnlyApiBeneficiaryReport"
                    component={OnlyApiBeneficiaryReport}
                />
                <InnerLayoutRoute
                    path="/ViewBeneficiary"
                    component={ViewBeneficiary}
                />
                <InnerLayoutRoute
                    path="/ViewOwnBeneficiary"
                    component={ViewOwnBeneficiary}
                />
                <InnerLayoutRoute
                    path="/AddOwnBeneficiary"
                    component={AddOwnBeneficiary}
                />
                <InnerLayoutRoute
                    path="/UPITransferReport"
                    component={UPITransferReport}
                />
                <InnerLayoutRoute
                    path="/ProviderWisePerformanceGraph"
                    component={ProviderWisePerformanceGraph}
                />
                <InnerLayoutRoute path="/OTTReport" component={OTTReport} />
                <InnerLayoutRoute
                    path="/BusBookingReport"
                    component={BusBookingReport}
                />
                <InnerLayoutRoute
                    path="/AccountOpeningReport"
                    component={AccountOpeningReport}
                />
                <InnerLayoutRoute
                    path="/CIBILScoreReport"
                    component={CIBILScoreReport}
                />
                <InnerLayoutRoute
                    path="/DenominationDetails/DenominationMapping"
                    component={DenominationMapping}
                />
                <InnerLayoutRoute path="/MenuAdd" component={MenuAdd} />
                <InnerLayoutRoute
                    path="/BulkMessageIndex"
                    exact
                    component={BulkMessageIndex}
                />
                <InnerLayoutRoute
                    path="/Payout"
                    exact
                    component={PayoutIndex}
                />
                <InnerLayoutRoute
                    path="/PayoutTransaction"
                    exact
                    component={PayoutTransaction}
                />
                <InnerLayoutRoute
                    path="/PayoutV1"
                    exact
                    component={PayoutIndexV1}
                />
                <InnerLayoutRoute
                    path="/PayoutTransactionV1"
                    exact
                    component={PayoutTransactionV1}
                />
                <InnerLayoutRoute
                    path="/PayoutTransactionV2"
                    exact
                    component={PayoutTransactionV2}
                />
                <InnerLayoutRoute
                    path="/OnlyApiPayoutTransaction"
                    exact
                    component={OnlyApiPayoutTransaction}
                />

                <InnerLayoutRoute
                    path="/SmartPayTransaction"
                    exact
                    component={SmartPayTransaction}
                />
                <InnerLayoutRoute
                    path="/OTTTransaction"
                    exact
                    component={OTTTransaction}
                />
                <InnerLayoutRoute
                    path="/PSPayout"
                    exact
                    component={PaysprintPayout}
                />
                <InnerLayoutRoute
                    path="/IMPPayout"
                    exact
                    component={IMoneyPayPayout}
                />
                <InnerLayoutRoute
                    path="/JJPayoutTransfer"
                    exact
                    component={JaiJuiPayout}
                />
                <InnerLayoutRoute path="/PPPayout" exact component={PPPayout} />
                <InnerLayoutRoute
                    path="/PSUploadDocument"
                    exact
                    component={PaysprintUploadDocment}
                />
                <InnerLayoutRoute
                    path="/InvoiceSettings"
                    exact
                    component={InvoiceSettings}
                />
                <InnerLayoutRoute
                    path="/CyberPlateSettings"
                    exact
                    component={CyberPlateSettings}
                />
                <InnerLayoutRoute
                    path="/CyberPlateSettings/Index"
                    exact
                    component={CyberPlateSettings}
                />
                <InnerLayoutRoute path="/Invoice" exact component={Invoice} />
                <InnerLayoutRoute
                    path="/InvoiceSettings/Index"
                    exact
                    component={InvoiceSettings}
                />
                <InnerLayoutRoute
                    path="/PaymentGateWaySetting"
                    exact
                    component={PaymentGateWaySetting}
                />
                <InnerLayoutRoute
                    path="/UserwisePaymentGateway"
                    exact
                    component={UserwisePaymentGateway}
                />
                <InnerLayoutRoute
                    path="/AEPSSetting"
                    exact
                    component={AEPSSetting}
                />
                <InnerLayoutRoute
                    path="/MicroATMSetting"
                    exact
                    component={MicroATMSetting}
                />
                <InnerLayoutRoute
                    path="/EcollectionSetting"
                    exact
                    component={EcollectionSetting}
                />
                <InnerLayoutRoute
                    path="/Fund/GatewayTransaction"
                    exact
                    component={GatewayTransaction}
                />
                <InnerLayoutRoute
                    path="/GSTSummary"
                    exact
                    component={GSTSummary}
                />
                <InnerLayoutRoute path="/GSTHold" exact component={GSTHold} />
                <InnerLayoutRoute
                    path="/Users/Inactive"
                    exact
                    component={InActiveUsers}
                />
                <InnerLayoutRoute path="/Ticket" component={Ticket} />
                <InnerLayoutRoute
                    path="/TicketReport"
                    component={TicketReport}
                />
                <InnerLayoutRoute
                    path="/BalanceCapping"
                    component={BalanceCappingUserwise}
                />
                <InnerLayoutRoute
                    path="/OperatorSale"
                    component={OperatorSale}
                />
                <InnerLayoutRoute
                    path="/LoginHistory"
                    component={LoginHistory}
                />
                <InnerLayoutRoute
                    path="/Users/UserWiseBulkAction"
                    exact
                    component={UserWiseBulkAction}
                />
                <InnerLayoutRoute
                    path="/UserWiseBulkActionSDAndDist"
                    exact
                    component={UserWiseBulkActionSDAndDist}
                />
                <InnerLayoutRoute
                    path="/DMTBankSetting"
                    exact
                    component={DMTBankSetting}
                />
                <InnerLayoutRoute path="/AddVoucher" component={AddVoucher} />
                <InnerLayoutRoute path="/Outstanding" component={Outstanding} />
                <InnerLayoutRoute
                    path="/DistributerOutStandingDetailsReport"
                    component={DistributerOutStandingDetailsReport}
                />
                <InnerLayoutRoute
                    path="/BalanceSheetReport"
                    component={BalanceSheetReport}
                />
                <InnerLayoutRoute
                    path="/VoucherModeReport"
                    component={VoucherModeReport}
                />
                <InnerLayoutRoute
                    path="/ApproveVoucher"
                    component={ApproveVoucher}
                />
                <InnerLayoutRoute
                    path="/CreditRequest"
                    component={CreditRequest}
                />
                <InnerLayoutRoute
                    path="/CreditRequestSetting"
                    component={CreditRequestSetting}
                />
                <InnerLayoutRoute
                    path="/ReportVoucher"
                    component={ReportVoucher}
                />
                <InnerLayoutRoute
                    path="/SenderBeneficiaryReport"
                    exact
                    component={SenderBeneficiaryReport}
                />
                <InnerLayoutRoute
                    path="/CF_UPITransferDocument"
                    exact
                    component={APIDocumentUPICF}
                />
                <InnerLayoutRoute
                    path="/UPITransferAPIDocument"
                    exact
                    component={UPITransferAPIDocument}
                />
                <InnerLayoutRoute
                    path="/CP_UPITransferDocument"
                    exact
                    component={APIDocumentUPICP}
                />
                <InnerLayoutRoute
                    path="/MNL_UPITransferDocument"
                    exact
                    component={APIDocumentUPICF}
                />
                <InnerLayoutRoute
                    path="/MNLDMTSender_Search"
                    exact
                    component={() => (
                        <MyNetLinkDMTSenderSearch ActiveDMTName="MyNetLinkDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/PaytmSenderSearch"
                    exac
                    component={() => <PaytmSenderSearch ActiveDMTName="PDMT" />}
                />
                <InnerLayoutRoute
                    path="/AlleDMTSenderSearch"
                    exact
                    component={() => (
                        <AlleDMTSenderSearch ActiveDMTName="AlleDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/IPSenderSearch"
                    exact
                    component={() => <IPSenderSearch ActiveDMTName="IDMT" />}
                />
                <InnerLayoutRoute
                    path="/MMoneySenderSearch"
                    exact
                    component={() => (
                        <MMoneySenderSearch ActiveDMTName="MasterMoneyDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/ESenderSearch"
                    exact
                    component={() => (
                        <ESenderSearch ActiveDMTName="ePocketDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/OpenBankSenderSearch"
                    exact
                    component={() => (
                        <OpenBankSenderSearch ActiveDMTName="OpenBankDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/PC_SenderSearch"
                    exact
                    component={() => (
                        <PaytmCCFSenderSearch ActiveDMTName="PaytmCCFDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/WPC_SenderSearch"
                    exact
                    component={() => (
                        <WhiteLabelPaytmCCFSenderSearch ActiveDMTName="PayinDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/RP_SenderSearch"
                    exact
                    component={() => (
                        <RazorpayDMTSenderSearch ActiveDMTName="Razorpay" />
                    )}
                />
                <InnerLayoutRoute
                    path="/ICashSenderSearch"
                    exact
                    component={() => (
                        <ICashSenderSearch ActiveDMTName="ICashDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/ICompositeSenderSearch"
                    exact
                    component={() => (
                        <ICompositeSenderSearch ActiveDMTName="ICICI_Composite" />
                    )}
                />
                <InnerLayoutRoute
                    path="/MahagramDMTSenderSearch"
                    exact
                    component={() => (
                        <MahagramDMTSenderSearch ActiveDMTName="Mahagram" />
                    )}
                />
                <InnerLayoutRoute
                    path="/EkoDMTSenderSearch"
                    exact
                    component={() => <EkoDMTSenderSearch ActiveDMTName="Eko" />}
                />
                <InnerLayoutRoute
                    path="/AB_SenderSearch"
                    exact
                    component={() => (
                        <AmbikaDMTSenderSearch ActiveDMTName="Ambika" />
                    )}
                />
                <InnerLayoutRoute
                    path="/ROP_DMTSenderSearch"
                    exact
                    component={() => (
                        <RoundPayDMTSenderSearch ActiveDMTName=" " />
                    )}
                />
                <InnerLayoutRoute
                    path="/CIT_DMTSenderSearch"
                    exact
                    component={() => (
                        <ClareInfoTechDMTSenderSearch ActiveDMTName=" " />
                    )}
                />
                <InnerLayoutRoute
                    path="/VW_DMTSenderSearch"
                    exact
                    component={() => (
                        <VastWebDMTSenderSearch ActiveDMTName=" " />
                    )}
                />
                <InnerLayoutRoute
                    path="/LF_DMTSenderSearch"
                    exact
                    component={() => (
                        <LevinDMTSenderSearch ActiveDMTName="LevinDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/IG_DMTSenderSearch"
                    exact
                    component={() => (
                        <IMPSGuruDMTSenderSearch ActiveDMTName=" " />
                    )}
                />
                <InnerLayoutRoute
                    path="/NTDMT_SenderSearch"
                    exact
                    component={() => <NTDMTSenderSearch ActiveDMTName=" " />}
                />
                <InnerLayoutRoute
                    path="/NT5LDMT_SenderSearch"
                    exact
                    component={() => <NTDMT5LSenderSearch ActiveDMTName=" " />}
                />
                <InnerLayoutRoute
                    path="/PU_SenderSearch"
                    exact
                    component={() => (
                        <PayUDMTSenderSearch ActiveDMTName="PayU" />
                    )}
                />
                <InnerLayoutRoute
                    path="/PS_SenderSearch"
                    exact
                    component={() => (
                        <PaysprintDMTSenderSearch ActiveDMTName="Paysprint" />
                    )}
                />
                <InnerLayoutRoute
                    path="/CS_SenderSearch"
                    exact
                    component={() => (
                        <CASADMTSenderSearch ActiveDMTName="CasaDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/ZP_DMTSenderSearch"
                    exact
                    component={() => (
                        <ZPlusDMTSenderSearch ActiveDMTName="ZPlusDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/CDMT_SenderSearch"
                    exact
                    component={() => (
                        <CDMTSenderSearch ActiveDMTName="Cyberplate" />
                    )}
                />
                {/* <InnerLayoutRoute
                    exact
                    component={() => (
                        <POMDMTSenderSearch ActiveDMTName="PayOneMoneyDMT" />
                    )}
                />  */}
                <InnerLayoutRoute
                    path="/JJ_SenderSearch"
                    exact
                    component={() => (
                        <JaiJuiDMTSenderSearch ActiveDMTName="JaiJuiDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/SenderSearch"
                    exact
                    component={() => <CommonDMTAsPayoutSenderSearch />}
                />
                <InnerLayoutRoute
                    path="/E_Payout"
                    exact
                    component={() => <EZYPayoutSenderSearch />}
                />
                <InnerLayoutRoute
                    path="/CF_SenderSearch"
                    exact
                    component={() => (
                        <CashFreeSenderSearch ActiveDMTName="CashFree" />
                    )}
                />
                <InnerLayoutRoute
                    path="/EZPSenderSearch"
                    exact
                    component={() => (
                        <EzyPaySenderSearch ActiveDMTName="EzyPay" />
                    )}
                />
                <InnerLayoutRoute
                    path="/EZPV1SenderSearch"
                    exact
                    component={() => (
                        <EzyPayV1SenderSearch ActiveDMTName="EZYPayV1DMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/NBDMT_SenderSearch"
                    exact
                    component={() => (
                        <NSDLBankSenderSearch ActiveDMTName="NSDLBankDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/OADMT_SenderSearch"
                    exact
                    component={() => (
                        <OnlyApiSenderSearch ActiveDMTName="OnlyApiDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/PPISenderAdd"
                    exact
                    component={() => (
                        <PayPointSenderAdd ActivePPIName="PayPoint" />
                    )}
                />
                <InnerLayoutRoute
                    path="/PS_PPIAgentRegistration"
                    exact
                    component={() => (
                        <PaysprintAgentRegistration ActivePPIName="Paysprint" />
                    )}
                />
                <InnerLayoutRoute
                    path="/EZPTMSenderSearch"
                    exact
                    component={() => (
                        <EzyPayPaytmSenderSearch ActiveDMTName="EzyPayPaytm" />
                    )}
                />
                <InnerLayoutRoute
                    path="/ZPP_SenderSearch"
                    exact
                    component={() => (
                        <ZPlusPayoutDMTSenderSearch ActiveDMTName="ZPlusPayout" />
                    )}
                />
                <InnerLayoutRoute
                    path="/H_SenderSearch"
                    exact
                    component={() => (
                        <HyptoDMTSenderSearch ActiveDMTName="HyptoDMT" />
                    )}
                />
                <InnerLayoutRoute
                    path="/PSCreateVPA"
                    exact
                    component={() => <PSCreateVPA />}
                />
                <InnerLayoutRoute
                    path="/RPCreateQR"
                    exact
                    component={() => <RPCreateQR />}
                />
                <InnerLayoutRoute
                    path="/MerchantOnboarding"
                    component={MerchantOnboarding}
                />
                <InnerLayoutRoute
                    path="/OnboardingReport"
                    component={OnboardingReport}
                />
                <InnerLayoutRoute
                    path="/OnlyAPIOnboarding"
                    component={OnlyAPIOnboarding}
                />
                <InnerLayoutRoute
                    path="/EditNSDLOnboarding"
                    component={EditNSDLOnboarding}
                />
                <InnerLayoutRoute
                    path="/BulkOnboarding"
                    component={BulkOnboarding}
                />
                <InnerLayoutRoute
                    path="/OnlyAPIBulkOnboarding"
                    component={OnlyAPIBulkOnboarding}

                />
                <InnerLayoutRoute
                    path="/BulkUpdateTIDMID"
                    component={BulkUpdateTIDMID}
                />
            </InnerLayout>
        </Route>
    );
};

export default InnerLayoutNavigator;
